/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `Any` scalar type represents any valid GraphQL value. */
  Any: { input: any; output: any; }
  /** The `DateTime` scalar type represents a date and time with time zone offset information. */
  DateTime: { input: any; output: any; }
  /** The `Long` scalar type represents a signed 64-bit integer. */
  Long: { input: any; output: any; }
  /** The `UUID` scalar type represents a Universally Unique Identifier (UUID) as defined by RFC 9562. */
  UUID: { input: any; output: any; }
};

export type AddAnswerInput = {
  data: Scalars['String']['input'];
  questionId: Scalars['UUID']['input'];
  sessionId: Scalars['UUID']['input'];
};

export type AddAvatarInput = {
  bodyColor?: InputMaybe<Scalars['String']['input']>;
  bodyId?: InputMaybe<Scalars['UUID']['input']>;
  eyeColor?: InputMaybe<Scalars['String']['input']>;
  hairColor?: InputMaybe<Scalars['String']['input']>;
  helperId?: InputMaybe<Scalars['UUID']['input']>;
  pantsColor?: InputMaybe<Scalars['String']['input']>;
  shirtColor?: InputMaybe<Scalars['String']['input']>;
  shoesColor?: InputMaybe<Scalars['String']['input']>;
  studentId: Scalars['UUID']['input'];
};

/** Create/add company */
export type AddCompanyInput = {
  /** Company description [optional] */
  description: Scalars['String']['input'];
  /** Company name */
  name: Scalars['String']['input'];
  /** E.g., School, Hospital, PrivatePractice */
  type: CompanyType;
};

export type AddCompanyPayload = {
  __typename?: 'AddCompanyPayload';
  company: CompanyDto;
};

export type AddCompanySubscriptionError = EntityNotFoundError | UnknownError | ValidationError;

export type AddCompanySubscriptionInput = {
  companyId: Scalars['UUID']['input'];
  subscriptionId: Scalars['UUID']['input'];
};

export type AddCompanySubscriptionPayload = {
  __typename?: 'AddCompanySubscriptionPayload';
  companySubscription?: Maybe<CompanySubscription>;
  errors?: Maybe<Array<AddCompanySubscriptionError>>;
};

export type AddCustomFieldInput = {
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
  placeholder?: InputMaybe<Scalars['String']['input']>;
  position: Scalars['Int']['input'];
  required: Scalars['Boolean']['input'];
  type: CustomFieldType;
  validationRule?: InputMaybe<Scalars['String']['input']>;
};

export type AddLocationError = UnknownError;

export type AddLocationInput = {
  city: Scalars['String']['input'];
  companyId: Scalars['UUID']['input'];
  country: Scalars['String']['input'];
  name: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  state: Scalars['String']['input'];
  streetLineOne: Scalars['String']['input'];
  streetLineTwo?: InputMaybe<Scalars['String']['input']>;
};

export type AddLocationPayload = {
  __typename?: 'AddLocationPayload';
  errors?: Maybe<Array<AddLocationError>>;
  location?: Maybe<LocationDto>;
};

export type AddPersonError = EntityBusinessRuleError | EntityNotFoundError | UnknownError | ValidationError;

export type AddPersonInput = {
  companyId?: InputMaybe<Scalars['UUID']['input']>;
  email: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  firstName: Scalars['String']['input'];
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  locationIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
  userRole: PersonRole;
};

export type AddPersonPayload = {
  __typename?: 'AddPersonPayload';
  errors?: Maybe<Array<AddPersonError>>;
  person?: Maybe<Person>;
};

export type AddSessionNoteError = EntityNotFoundError | UnknownError | ValidationError;

export type AddSessionNoteInput = {
  body: Scalars['String']['input'];
  data?: InputMaybe<Scalars['String']['input']>;
  origin: NoteOriginType;
  sessionId: Scalars['UUID']['input'];
  type: NoteTypeEnum;
};

export type AddSessionNotePayload = {
  __typename?: 'AddSessionNotePayload';
  errors?: Maybe<Array<AddSessionNoteError>>;
  sessionNote?: Maybe<SessionNote>;
};

export type AddStudentError = EntityNotFoundError | UnknownError | ValidationError;

export type AddStudentInput = {
  customFields?: InputMaybe<Array<CustomFieldInput>>;
  dob: Scalars['DateTime']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  middleName?: InputMaybe<Scalars['String']['input']>;
  parentEmail?: InputMaybe<Scalars['String']['input']>;
  parentPhone?: InputMaybe<Scalars['String']['input']>;
  personIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  postalCode: Scalars['String']['input'];
};

export type AddStudentNoteError = EntityNotFoundError | UnknownError | ValidationError;

export type AddStudentNoteInput = {
  body: Scalars['String']['input'];
  data?: InputMaybe<Scalars['String']['input']>;
  origin: NoteOriginType;
  studentId: Scalars['UUID']['input'];
  type: NoteTypeEnum;
};

export type AddStudentNotePayload = {
  __typename?: 'AddStudentNotePayload';
  errors?: Maybe<Array<AddStudentNoteError>>;
  studentNote?: Maybe<StudentNote>;
};

export type AddStudentPayload = {
  __typename?: 'AddStudentPayload';
  errors?: Maybe<Array<AddStudentError>>;
  student?: Maybe<Student>;
};

export type AddWorkListError = EntityBusinessRuleError | EntityDuplicateError | EntityNotFoundError | UnknownError | ValidationError;

export type AddWorkListInput = {
  personId: Scalars['UUID']['input'];
  sessionId: Scalars['UUID']['input'];
};

export type AddWorkListPayload = {
  __typename?: 'AddWorkListPayload';
  errors?: Maybe<Array<AddWorkListError>>;
  workList?: Maybe<WorkList>;
};

export type AddWorkListsInput = {
  sessionId: Scalars['UUID']['input'];
};

export type Adventure = {
  __typename?: 'Adventure';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  file?: Maybe<CoreFile>;
  fileId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
  scenes: Array<Scene>;
  sessions: Array<Session>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AdventureDto = {
  __typename?: 'AdventureDTO';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  coreFile?: Maybe<CoreFileDto>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fileId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
  scenes: Array<SceneDto>;
  sessions: Array<SessionDto>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AdventureSortInput = {
  archivedAt?: InputMaybe<SortEnumType>;
  coreFile?: InputMaybe<CoreFileSortInput>;
  createdAt?: InputMaybe<SortEnumType>;
  deletedAt?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  fileId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  position?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

export type Answer = {
  __typename?: 'Answer';
  answerCategories: Array<AnswerCategory>;
  answerFlags: Array<AnswerFlag>;
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  data?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  enteredAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  keyWordExtractionData?: Maybe<Scalars['String']['output']>;
  question?: Maybe<Question>;
  questionId: Scalars['UUID']['output'];
  sentimentAnalysisData?: Maybe<Scalars['String']['output']>;
  session?: Maybe<Session>;
  sessionId: Scalars['UUID']['output'];
  status?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AnswerCategory = {
  __typename?: 'AnswerCategory';
  answer?: Maybe<Answer>;
  answerId: Scalars['UUID']['output'];
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  category?: Maybe<Category>;
  categoryId: Scalars['UUID']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  keyword?: Maybe<Keyword>;
  keywordId?: Maybe<Scalars['UUID']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AnswerCategoryDto = {
  __typename?: 'AnswerCategoryDTO';
  answer?: Maybe<AnswerDto>;
  answerId: Scalars['UUID']['output'];
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  category?: Maybe<CategoryDto>;
  categoryId: Scalars['UUID']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  keyword?: Maybe<KeywordDto>;
  keywordId?: Maybe<Scalars['UUID']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AnswerDto = {
  __typename?: 'AnswerDTO';
  answerCategories: Array<AnswerCategoryDto>;
  answerFlags: Array<AnswerFlagDto>;
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  data?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  enteredAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  keyWordExtractionData?: Maybe<Scalars['String']['output']>;
  question?: Maybe<QuestionDto>;
  questionId: Scalars['UUID']['output'];
  sentimentAnalysisData?: Maybe<Scalars['String']['output']>;
  session?: Maybe<SessionDto>;
  sessionId: Scalars['UUID']['output'];
  status?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AnswerFlag = {
  __typename?: 'AnswerFlag';
  answer?: Maybe<Answer>;
  answerId: Scalars['UUID']['output'];
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  flag?: Maybe<Flag>;
  flagId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  question?: Maybe<Question>;
  questionId: Scalars['UUID']['output'];
  status?: Maybe<Scalars['String']['output']>;
  trait?: Maybe<Trait>;
  traitId?: Maybe<Scalars['UUID']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AnswerFlagDto = {
  __typename?: 'AnswerFlagDTO';
  answer?: Maybe<AnswerDto>;
  answerId: Scalars['UUID']['output'];
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  flag?: Maybe<FlagDto>;
  flagId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  question?: Maybe<QuestionDto>;
  questionId: Scalars['UUID']['output'];
  status?: Maybe<Scalars['String']['output']>;
  trait?: Maybe<TraitDto>;
  traitId?: Maybe<Scalars['UUID']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum AnswerGroup {
  All = 'ALL',
  Boolean = 'BOOLEAN',
  Composite = 'COMPOSITE',
  EnglishTweenScreen = 'ENGLISH_TWEEN_SCREEN',
  EnglishTScreen = 'ENGLISH_T_SCREEN',
  Freeform = 'FREEFORM',
  Multiselect = 'MULTISELECT',
  Scale = 'SCALE'
}

export type AnswerResult = Answer | XValidationError;

/** A connection to a list of items. */
export type AnswersByConditionConnection = {
  __typename?: 'AnswersByConditionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AnswersByConditionEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Answer>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AnswersByConditionEdge = {
  __typename?: 'AnswersByConditionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Answer;
};

/** Defines when a policy shall be executed. */
export enum ApplyPolicy {
  /** After the resolver was executed. */
  AfterResolver = 'AFTER_RESOLVER',
  /** Before the resolver was executed. */
  BeforeResolver = 'BEFORE_RESOLVER',
  /** The policy is applied in the validation step before the execution. */
  Validation = 'VALIDATION'
}

export type AssessmentData = {
  __typename?: 'AssessmentData';
  ace: Scalars['Int']['output'];
  aces: Array<Scalars['String']['output']>;
  adhd: Scalars['Int']['output'];
  anxiety: Scalars['Int']['output'];
  deathInFamily: Scalars['Boolean']['output'];
  deathInFamilyWho: Scalars['String']['output'];
  depression: Scalars['Int']['output'];
  environmentalRiskFactorsFlags: Array<Scalars['String']['output']>;
  externalizing: Scalars['Int']['output'];
  feProtective: Scalars['Float']['output'];
  feRisk: Scalars['Float']['output'];
  internalizing: Scalars['Int']['output'];
  isSeeingMentalHealthProfessional: Scalars['Boolean']['output'];
  livesWith: Scalars['String']['output'];
  pce: Scalars['Int']['output'];
  pces: Array<Scalars['String']['output']>;
  socialRiskFactorFlags: Array<Scalars['String']['output']>;
  suicidality: Scalars['Int']['output'];
  youProtective: Scalars['Int']['output'];
  youRisk: Scalars['Int']['output'];
};

export type AssessmentDataDto = {
  __typename?: 'AssessmentDataDTO';
  ace: Scalars['Int']['output'];
  aces: Array<Scalars['String']['output']>;
  adhd: Scalars['Int']['output'];
  anxiety: Scalars['Int']['output'];
  deathInFamily: Scalars['Boolean']['output'];
  deathInFamilyWho: Scalars['String']['output'];
  depression: Scalars['Int']['output'];
  environmentalRiskFactorsFlags: Array<Scalars['String']['output']>;
  externalizing: Scalars['Int']['output'];
  feProtective: Scalars['Float']['output'];
  feRisk: Scalars['Float']['output'];
  internalizing: Scalars['Int']['output'];
  isSeeingMentalHealthProfessional: Scalars['Boolean']['output'];
  livesWith: Scalars['String']['output'];
  pce: Scalars['Int']['output'];
  pces: Array<Scalars['String']['output']>;
  positiveFinding: Scalars['Int']['output'];
  socialRiskFactorFlags: Array<Scalars['String']['output']>;
  suicidality: Scalars['Int']['output'];
  youProtective: Scalars['Int']['output'];
  youRisk: Scalars['Int']['output'];
};

export type AssessmentDataSortInput = {
  ace?: InputMaybe<SortEnumType>;
  adhd?: InputMaybe<SortEnumType>;
  anxiety?: InputMaybe<SortEnumType>;
  deathInFamily?: InputMaybe<SortEnumType>;
  deathInFamilyWho?: InputMaybe<SortEnumType>;
  depression?: InputMaybe<SortEnumType>;
  externalizing?: InputMaybe<SortEnumType>;
  feProtective?: InputMaybe<SortEnumType>;
  feRisk?: InputMaybe<SortEnumType>;
  internalizing?: InputMaybe<SortEnumType>;
  isSeeingMentalHealthProfessional?: InputMaybe<SortEnumType>;
  livesWith?: InputMaybe<SortEnumType>;
  pce?: InputMaybe<SortEnumType>;
  suicidality?: InputMaybe<SortEnumType>;
  youProtective?: InputMaybe<SortEnumType>;
  youRisk?: InputMaybe<SortEnumType>;
};

export type AssignLocationPersonsError = EntityLockedError | EntityNotFoundError | UnknownError | ValidationError;

export type AssignLocationPersonsInput = {
  locationId: Scalars['UUID']['input'];
  personIds: Array<Scalars['UUID']['input']>;
};

export type AssignLocationPersonsPayload = {
  __typename?: 'AssignLocationPersonsPayload';
  errors?: Maybe<Array<AssignLocationPersonsError>>;
  location?: Maybe<Location>;
};

export type AssignPersonLocationsError = EntityLockedError | EntityNotFoundError | UnknownError | ValidationError;

export type AssignPersonLocationsInput = {
  locationIds: Array<Scalars['UUID']['input']>;
  personId: Scalars['UUID']['input'];
};

export type AssignPersonLocationsPayload = {
  __typename?: 'AssignPersonLocationsPayload';
  errors?: Maybe<Array<AssignPersonLocationsError>>;
  person?: Maybe<Person>;
};

export type AssignPersonStudentsError = EntityLockedError | EntityNotFoundError | UnknownError | ValidationError;

export type AssignPersonStudentsInput = {
  personId: Scalars['UUID']['input'];
  studentIds: Array<Scalars['UUID']['input']>;
};

export type AssignPersonStudentsPayload = {
  __typename?: 'AssignPersonStudentsPayload';
  errors?: Maybe<Array<AssignPersonStudentsError>>;
  person?: Maybe<Person>;
};

export type AssignStudentPersonsError = EntityLockedError | EntityNotFoundError | UnknownError | ValidationError;

export type AssignStudentPersonsInput = {
  personIds: Array<Scalars['UUID']['input']>;
  studentId: Scalars['UUID']['input'];
};

export type AssignStudentPersonsPayload = {
  __typename?: 'AssignStudentPersonsPayload';
  errors?: Maybe<Array<AssignStudentPersonsError>>;
  student?: Maybe<Student>;
};

export type AuthenticateInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type AuthenticationResult = {
  __typename?: 'AuthenticationResult';
  accessToken?: Maybe<Scalars['String']['output']>;
  expires?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};


export type AuthenticationResultExpiresArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type Avatar = {
  __typename?: 'Avatar';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  bodyColor?: Maybe<Scalars['String']['output']>;
  bodyCoreFile?: Maybe<CoreFile>;
  bodyId?: Maybe<Scalars['UUID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  eyeColor?: Maybe<Scalars['String']['output']>;
  eyeCoreFile?: Maybe<CoreFile>;
  eyeId?: Maybe<Scalars['UUID']['output']>;
  hairColor?: Maybe<Scalars['String']['output']>;
  hairCoreFile?: Maybe<CoreFile>;
  hairId?: Maybe<Scalars['UUID']['output']>;
  helperCoreFile?: Maybe<CoreFile>;
  helperId?: Maybe<Scalars['UUID']['output']>;
  id: Scalars['UUID']['output'];
  outfitCoreFile?: Maybe<CoreFile>;
  outfitId?: Maybe<Scalars['UUID']['output']>;
  pantsColor?: Maybe<Scalars['String']['output']>;
  sessions?: Maybe<Array<Session>>;
  shirtColor?: Maybe<Scalars['String']['output']>;
  shoesColor?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  student?: Maybe<Student>;
  studentId: Scalars['UUID']['output'];
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AvatarDto = {
  __typename?: 'AvatarDTO';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  bodyColor?: Maybe<Scalars['String']['output']>;
  bodyCoreFile?: Maybe<CoreFileDto>;
  bodyId?: Maybe<Scalars['UUID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  eyeColor?: Maybe<Scalars['String']['output']>;
  eyeCoreFile?: Maybe<CoreFileDto>;
  eyeId?: Maybe<Scalars['UUID']['output']>;
  hairColor?: Maybe<Scalars['String']['output']>;
  hairCoreFile?: Maybe<CoreFileDto>;
  hairId?: Maybe<Scalars['UUID']['output']>;
  helperCoreFile?: Maybe<CoreFileDto>;
  helperId?: Maybe<Scalars['UUID']['output']>;
  id: Scalars['UUID']['output'];
  outfitCoreFile?: Maybe<CoreFileDto>;
  outfitId?: Maybe<Scalars['UUID']['output']>;
  pantsColor?: Maybe<Scalars['String']['output']>;
  sessions: Array<SessionDto>;
  shirtColor?: Maybe<Scalars['String']['output']>;
  shoesColor?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  student?: Maybe<StudentDto>;
  studentId: Scalars['UUID']['output'];
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AvatarResult = Avatar | XValidationError;

export type AvatarSortInput = {
  archivedAt?: InputMaybe<SortEnumType>;
  bodyColor?: InputMaybe<SortEnumType>;
  bodyCoreFile?: InputMaybe<CoreFileSortInput>;
  bodyId?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  deletedAt?: InputMaybe<SortEnumType>;
  eyeColor?: InputMaybe<SortEnumType>;
  eyeCoreFile?: InputMaybe<CoreFileSortInput>;
  eyeId?: InputMaybe<SortEnumType>;
  hairColor?: InputMaybe<SortEnumType>;
  hairCoreFile?: InputMaybe<CoreFileSortInput>;
  hairId?: InputMaybe<SortEnumType>;
  helperCoreFile?: InputMaybe<CoreFileSortInput>;
  helperId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  outfitCoreFile?: InputMaybe<CoreFileSortInput>;
  outfitId?: InputMaybe<SortEnumType>;
  pantsColor?: InputMaybe<SortEnumType>;
  shirtColor?: InputMaybe<SortEnumType>;
  shoesColor?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  student?: InputMaybe<StudentSortInput>;
  studentId?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

export type BeginSessionError = EntityNotFoundError | UnknownError | ValidationError;

export type BeginSessionInput = {
  category: SessionCategoryType;
  studentId: Scalars['UUID']['input'];
  type: SessionType;
};

export type BeginSessionPayload = {
  __typename?: 'BeginSessionPayload';
  errors?: Maybe<Array<BeginSessionError>>;
  session?: Maybe<Session>;
};

export type Category = {
  __typename?: 'Category';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  isAIGenerated?: Maybe<Scalars['Boolean']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CategoryDto = {
  __typename?: 'CategoryDTO';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  isAIGenerated?: Maybe<Scalars['Boolean']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CategoryRankingDto = {
  __typename?: 'CategoryRankingDTO';
  categoryTitle: Scalars['String']['output'];
  categoryType: Scalars['String']['output'];
  rank: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CategoryTypeRankingDto = {
  __typename?: 'CategoryTypeRankingDTO';
  groupKey: Scalars['String']['output'];
  questionId: Scalars['UUID']['output'];
  questionTitle: Scalars['String']['output'];
  rankings: Array<CategoryRankingDto>;
};

export enum CheckpointType {
  AdventureComplete = 'ADVENTURE_COMPLETE',
  AdventureSelected = 'ADVENTURE_SELECTED',
  AppClosed = 'APP_CLOSED',
  AtSchoolQuestions = 'AT_SCHOOL_QUESTIONS',
  AuthenticationSuccess = 'AUTHENTICATION_SUCCESS',
  AvatarSelected = 'AVATAR_SELECTED',
  DescribeAdultsQuestions = 'DESCRIBE_ADULTS_QUESTIONS',
  EnvironmentQuestions = 'ENVIRONMENT_QUESTIONS',
  FamilyQuestions = 'FAMILY_QUESTIONS',
  HappyOrSadQuestions = 'HAPPY_OR_SAD_QUESTIONS',
  HobbiesQuestions = 'HOBBIES_QUESTIONS',
  Opened = 'OPENED',
  PersonalProblemsQuestions = 'PERSONAL_PROBLEMS_QUESTIONS',
  PersonalQuestions = 'PERSONAL_QUESTIONS',
  PersonalSupportQuestions = 'PERSONAL_SUPPORT_QUESTIONS',
  PhysicalSignsQuestions = 'PHYSICAL_SIGNS_QUESTIONS',
  SuicidalityQuestions = 'SUICIDALITY_QUESTIONS',
  TiredOrAwakeQuestions = 'TIRED_OR_AWAKE_QUESTIONS',
  WorryQuestions = 'WORRY_QUESTIONS'
}

export type CloseSessionError = EntityCompletedError | EntityNotFoundError | UnknownError | ValidationError;

export type CloseSessionInput = {
  id: Scalars['UUID']['input'];
};

export type CloseSessionPayload = {
  __typename?: 'CloseSessionPayload';
  errors?: Maybe<Array<CloseSessionError>>;
  session?: Maybe<Session>;
};

/** A connection to a list of items. */
export type CompaniesConnection = {
  __typename?: 'CompaniesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CompaniesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Company>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CompaniesEdge = {
  __typename?: 'CompaniesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Company;
};

/** Represents a physical company */
export type Company = {
  __typename?: 'Company';
  abbreviation?: Maybe<Scalars['String']['output']>;
  activeUsers: Scalars['Int']['output'];
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  companyActionHistory: CompanyActionHistory;
  companyConsentPolicy: CompanyConsentPolicy;
  companyInterventionPolicy: CompanyInterventionPolicy;
  companySessionCategories: CompanySessionCategoryList;
  companyStudentAgeFlags: Array<CompanyStudentAgeFlags>;
  companySubscriptions: Array<CompanySubscription>;
  companyTopFlags: Array<FlagRankingDto>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  historyCompanys: Array<HistoryCompany>;
  id: Scalars['UUID']['output'];
  locations: Array<Location>;
  name?: Maybe<Scalars['String']['output']>;
  paidUsers: Scalars['Int']['output'];
  persons: Array<Person>;
  sessionStats: CompanySessionStats;
  sessions: Array<Session>;
  slug?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  students: Array<Student>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  weeklyReportFiles: Array<WeeklyReportFile>;
};

export type CompanyActionHistory = {
  __typename?: 'CompanyActionHistory';
  educationalMaterialsSent: Scalars['Int']['output'];
  referralsMade: Scalars['Int']['output'];
};

export type CompanyConsentPolicy = {
  __typename?: 'CompanyConsentPolicy';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  autoParentalConsent: Scalars['Boolean']['output'];
  company?: Maybe<Company>;
  companyId: Scalars['UUID']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  needParentalConsent: Scalars['Boolean']['output'];
  status?: Maybe<Scalars['String']['output']>;
  timeoutWindow?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CompanyConsentPolicyDto = {
  __typename?: 'CompanyConsentPolicyDTO';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  autoParentalConsent: Scalars['Boolean']['output'];
  company?: Maybe<CompanyDto>;
  companyId: Scalars['UUID']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  needParentalConsent: Scalars['Boolean']['output'];
  status?: Maybe<Scalars['String']['output']>;
  timeoutWindow?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CompanyConsentPolicySortInput = {
  archivedAt?: InputMaybe<SortEnumType>;
  autoParentalConsent?: InputMaybe<SortEnumType>;
  company?: InputMaybe<CompanySortInput>;
  companyId?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  deletedAt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  needParentalConsent?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  timeoutWindow?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

export type CompanyDto = {
  __typename?: 'CompanyDTO';
  abbreviation?: Maybe<Scalars['String']['output']>;
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  companyConsentPolicy: CompanyConsentPolicyDto;
  companyInterventionPolicy: CompanyInterventionPolicyDto;
  companySubscriptions: Array<CompanySubscriptionDto>;
  companyTopFlags: Array<CompanyTopFlagDto>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  historyCompanys: Array<HistoryCompanyDto>;
  id: Scalars['UUID']['output'];
  locations: Array<LocationDto>;
  name?: Maybe<Scalars['String']['output']>;
  paidUsers: Scalars['Int']['output'];
  persons: Array<PersonDto>;
  slug?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CompanyInterventionPolicy = {
  __typename?: 'CompanyInterventionPolicy';
  abuseAtHome: Scalars['Boolean']['output'];
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  company?: Maybe<Company>;
  companyId: Scalars['UUID']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  safeAtHome: Scalars['Boolean']['output'];
  status?: Maybe<Scalars['String']['output']>;
  suicide: Scalars['Boolean']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CompanyInterventionPolicyDto = {
  __typename?: 'CompanyInterventionPolicyDTO';
  abuseAtHome: Scalars['Boolean']['output'];
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  company?: Maybe<CompanyDto>;
  companyId: Scalars['UUID']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  safeAtHome: Scalars['Boolean']['output'];
  status?: Maybe<Scalars['String']['output']>;
  suicide: Scalars['Boolean']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CompanyInterventionPolicySortInput = {
  abuseAtHome?: InputMaybe<SortEnumType>;
  archivedAt?: InputMaybe<SortEnumType>;
  company?: InputMaybe<CompanySortInput>;
  companyId?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  deletedAt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  safeAtHome?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  suicide?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

export type CompanySessionCategoryList = {
  __typename?: 'CompanySessionCategoryList';
  rankings: Array<CategoryTypeRankingDto>;
};

export type CompanySessionStats = {
  __typename?: 'CompanySessionStats';
  beenBullied: Scalars['Int']['output'];
  crisisSupportIndicated: Scalars['Int']['output'];
  hasRecentDeath: Scalars['Int']['output'];
  inTherapy: Scalars['Int']['output'];
  intensiveSupportIndicated: Scalars['Int']['output'];
  preventionAndStrengthIndicated: Scalars['Int']['output'];
  supportIndicated: Scalars['Int']['output'];
};

/** Represents a physical company */
export type CompanySortInput = {
  abbreviation?: InputMaybe<SortEnumType>;
  archivedAt?: InputMaybe<SortEnumType>;
  companyConsentPolicy?: InputMaybe<CompanyConsentPolicySortInput>;
  companyInterventionPolicy?: InputMaybe<CompanyInterventionPolicySortInput>;
  createdAt?: InputMaybe<SortEnumType>;
  deletedAt?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  paidUsers?: InputMaybe<SortEnumType>;
  slug?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

export type CompanyStudentAgeFlags = {
  __typename?: 'CompanyStudentAgeFlags';
  ageAtSession: Scalars['Int']['output'];
  assessmentData?: Maybe<AssessmentData>;
  student?: Maybe<Student>;
};

export type CompanySubscription = {
  __typename?: 'CompanySubscription';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  company?: Maybe<Company>;
  companyId: Scalars['UUID']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  endDate: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  startDate: Scalars['DateTime']['output'];
  status?: Maybe<Scalars['String']['output']>;
  subscription?: Maybe<Subscription>;
  subscriptionId: Scalars['UUID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CompanySubscriptionDto = {
  __typename?: 'CompanySubscriptionDTO';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  company?: Maybe<CompanyDto>;
  companyId: Scalars['UUID']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  endDate: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  startDate: Scalars['DateTime']['output'];
  status?: Maybe<Scalars['String']['output']>;
  subscription?: Maybe<SubscriptionDto>;
  subscriptionId: Scalars['UUID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** A connection to a list of items. */
export type CompanySubscriptionsConnection = {
  __typename?: 'CompanySubscriptionsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CompanySubscriptionsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CompanySubscription>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CompanySubscriptionsEdge = {
  __typename?: 'CompanySubscriptionsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CompanySubscription;
};

export type CompanyTopFlag = {
  __typename?: 'CompanyTopFlag';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  company?: Maybe<Company>;
  companyId: Scalars['UUID']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  flag?: Maybe<Flag>;
  flagId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  question?: Maybe<Question>;
  questionId?: Maybe<Scalars['UUID']['output']>;
  rank: Scalars['Int']['output'];
  status?: Maybe<Scalars['String']['output']>;
  trait?: Maybe<Trait>;
  traitId?: Maybe<Scalars['UUID']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CompanyTopFlagDto = {
  __typename?: 'CompanyTopFlagDTO';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  company?: Maybe<CompanyDto>;
  companyId: Scalars['UUID']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  flag?: Maybe<FlagDto>;
  flagId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  question?: Maybe<QuestionDto>;
  questionId?: Maybe<Scalars['UUID']['output']>;
  rank: Scalars['Int']['output'];
  status?: Maybe<Scalars['String']['output']>;
  trait?: Maybe<TraitDto>;
  traitId?: Maybe<Scalars['UUID']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum CompanyType {
  Default = 'DEFAULT',
  Hospital = 'HOSPITAL',
  Medical = 'MEDICAL',
  Other = 'OTHER',
  PrivateClinic = 'PRIVATE_CLINIC',
  School = 'SCHOOL'
}

export type CoreFile = {
  __typename?: 'CoreFile';
  adventures: Array<Adventure>;
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  avatarBodies: Array<Avatar>;
  avatarEyes: Array<Avatar>;
  avatarHair: Array<Avatar>;
  avatarHelpers: Array<Avatar>;
  avatarOutfits: Array<Avatar>;
  blobName?: Maybe<Scalars['String']['output']>;
  blurHash?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  fileHash?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  fileSize: Scalars['Long']['output'];
  formats?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  locationId: Scalars['UUID']['output'];
  mimeType?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  storageAccount?: Maybe<Scalars['String']['output']>;
  storageContainer?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CoreFileDto = {
  __typename?: 'CoreFileDTO';
  adventures: Array<AdventureDto>;
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  avatarBodies: Array<AvatarDto>;
  avatarEyes: Array<AvatarDto>;
  avatarHair: Array<AvatarDto>;
  avatarHelpers: Array<AvatarDto>;
  avatarOutfits: Array<AvatarDto>;
  blobName?: Maybe<Scalars['String']['output']>;
  blurHash?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  fileHash?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  fileSize: Scalars['Long']['output'];
  formats?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  mimeType?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  storageAccount?: Maybe<Scalars['String']['output']>;
  storageContainer?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CoreFileSortInput = {
  archivedAt?: InputMaybe<SortEnumType>;
  blobName?: InputMaybe<SortEnumType>;
  blurHash?: InputMaybe<SortEnumType>;
  category?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  deletedAt?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  displayName?: InputMaybe<SortEnumType>;
  fileHash?: InputMaybe<SortEnumType>;
  fileName?: InputMaybe<SortEnumType>;
  fileSize?: InputMaybe<SortEnumType>;
  formats?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  locationId?: InputMaybe<SortEnumType>;
  mimeType?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  storageAccount?: InputMaybe<SortEnumType>;
  storageContainer?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

export type CustomField = {
  __typename?: 'CustomField';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  defaultValue?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  location?: Maybe<Location>;
  locationId: Scalars['UUID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  placeHolder?: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
  required: Scalars['Boolean']['output'];
  status?: Maybe<Scalars['String']['output']>;
  studentCustomFields: Array<StudentCustomField>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  validationRule?: Maybe<Scalars['String']['output']>;
};

export type CustomFieldDto = {
  __typename?: 'CustomFieldDTO';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  defaultValue?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  location?: Maybe<LocationDto>;
  locationId: Scalars['UUID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  placeHolder?: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
  required: Scalars['Boolean']['output'];
  status?: Maybe<Scalars['String']['output']>;
  studentCustomFields: Array<StudentCustomFieldDto>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  validationRule?: Maybe<Scalars['String']['output']>;
};

export type CustomFieldInput = {
  id: Scalars['UUID']['input'];
  value: Scalars['String']['input'];
};

export type CustomFieldPair = {
  __typename?: 'CustomFieldPair';
  id: Scalars['UUID']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export enum CustomFieldType {
  Select = 'SELECT',
  Text = 'TEXT'
}

export type DashboardStats = {
  __typename?: 'DashboardStats';
  changeFromLastWeek: Scalars['Int']['output'];
  currentLocationStudents: Scalars['Int']['output'];
  pendingConsent: Scalars['Int']['output'];
  sessionsCompleteThisWeek: Scalars['Int']['output'];
  totalStudents: Scalars['Int']['output'];
};

export type DuplicateCheckpointError = {
  __typename?: 'DuplicateCheckpointError';
  checkpoint: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type DuplicateField = {
  __typename?: 'DuplicateField';
  fieldName?: Maybe<Scalars['String']['output']>;
};

export type EditCompanyError = EntityBusinessRuleError | EntityNotFoundError | UnknownError | ValidationError;

/** Edit/update company record */
export type EditCompanyInput = {
  abbreviation?: InputMaybe<Scalars['String']['input']>;
  /** Do they have abuse at home protocol */
  abuseAtHome: Scalars['Boolean']['input'];
  /** Does the company have auto parental Consent */
  autoParentalConsent: Scalars['Boolean']['input'];
  /** Company ID */
  id: Scalars['UUID']['input'];
  /** Company name */
  name: Scalars['String']['input'];
  /** Does the company require parental Consent */
  needParentalConsent: Scalars['Boolean']['input'];
  /** How many users ahve they paid for */
  paidUsers?: InputMaybe<Scalars['Int']['input']>;
  /** Do they have safe at home protocol */
  safeAtHome: Scalars['Boolean']['input'];
  /** Do they have suicide protocol */
  suicide: Scalars['Boolean']['input'];
  /** Is there a timeout window */
  timeoutWindow?: InputMaybe<Scalars['Int']['input']>;
  /** E.g., School, Hospital, PrivatePractice */
  type: CompanyType;
};

export type EditCompanyPayload = {
  __typename?: 'EditCompanyPayload';
  company?: Maybe<Company>;
  errors?: Maybe<Array<EditCompanyError>>;
};

export type EditLocationError = EntityNotFoundError | ValidationError;

export type EditLocationInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  id: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  state: Scalars['String']['input'];
  streetLineOne: Scalars['String']['input'];
  streetLineTwo?: InputMaybe<Scalars['String']['input']>;
};

export type EditLocationPayload = {
  __typename?: 'EditLocationPayload';
  errors?: Maybe<Array<EditLocationError>>;
  location?: Maybe<Location>;
};

export type EditLocationStudentsError = EntityLockedError | EntityNotFoundError | UnknownError | ValidationError;

export type EditLocationStudentsInput = {
  locationId: Scalars['UUID']['input'];
  studentIds: Array<Scalars['UUID']['input']>;
};

export type EditLocationStudentsPayload = {
  __typename?: 'EditLocationStudentsPayload';
  errors?: Maybe<Array<EditLocationStudentsError>>;
  location?: Maybe<Location>;
};

export type EditPersonError = EntityLockedError | EntityNotFoundError | UnknownError | ValidationError;

export type EditPersonInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  firstName: Scalars['String']['input'];
  id: Scalars['UUID']['input'];
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  middleName?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
  userRole: PersonRole;
};

export type EditPersonPayload = {
  __typename?: 'EditPersonPayload';
  errors?: Maybe<Array<EditPersonError>>;
  person?: Maybe<Person>;
};

export type EditSessionError = EntityNotFoundError | UnknownError | ValidationError;

export type EditSessionInput = {
  adventureId: Scalars['UUID']['input'];
  avatarId: Scalars['UUID']['input'];
  sessionId: Scalars['UUID']['input'];
};

export type EditSessionPayload = {
  __typename?: 'EditSessionPayload';
  errors?: Maybe<Array<EditSessionError>>;
  session?: Maybe<Session>;
};

export type EditStudentChildEmailError = EntityNotFoundError | UnknownError | ValidationError;

export type EditStudentChildEmailInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

export type EditStudentChildEmailPayload = {
  __typename?: 'EditStudentChildEmailPayload';
  errors?: Maybe<Array<EditStudentChildEmailError>>;
  student?: Maybe<Student>;
};

export type EditStudentError = EntityNotFoundError | UnknownError | ValidationError;

export type EditStudentInput = {
  customFields?: InputMaybe<Array<CustomFieldInput>>;
  dob: Scalars['DateTime']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  id: Scalars['UUID']['input'];
  lastName: Scalars['String']['input'];
  middleName?: InputMaybe<Scalars['String']['input']>;
  parentEmail?: InputMaybe<Scalars['String']['input']>;
  parentPhone?: InputMaybe<Scalars['String']['input']>;
  postalCode: Scalars['String']['input'];
};

export type EditStudentLocationError = EntityNotFoundError | UnknownError | ValidationError;

export type EditStudentLocationInput = {
  id: Scalars['UUID']['input'];
  locationId: Scalars['UUID']['input'];
};

export type EditStudentLocationPayload = {
  __typename?: 'EditStudentLocationPayload';
  errors?: Maybe<Array<EditStudentLocationError>>;
  student?: Maybe<Student>;
};

export type EditStudentParentEmailError = EntityNotFoundError | UnknownError | ValidationError;

export type EditStudentParentEmailInput = {
  id: Scalars['UUID']['input'];
  parentEmail?: InputMaybe<Scalars['String']['input']>;
};

export type EditStudentParentEmailPayload = {
  __typename?: 'EditStudentParentEmailPayload';
  errors?: Maybe<Array<EditStudentParentEmailError>>;
  student?: Maybe<Student>;
};

export type EditStudentPayload = {
  __typename?: 'EditStudentPayload';
  errors?: Maybe<Array<EditStudentError>>;
  student?: Maybe<Student>;
};

export type EntityBusinessRuleError = Error & {
  __typename?: 'EntityBusinessRuleError';
  id: Scalars['UUID']['output'];
  message: Scalars['String']['output'];
  operationName: Scalars['String']['output'];
  /**
   * Unique code representing a request intended and generally attached to error objects. Use for user technical
   * support
   */
  referenceCode?: Maybe<Scalars['String']['output']>;
  ruleName: Scalars['String']['output'];
};

export type EntityCompletedError = Error & {
  __typename?: 'EntityCompletedError';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  entity?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  message: Scalars['String']['output'];
  /**
   * Unique code representing a request intended and generally attached to error objects. Use for user technical
   * support
   */
  referenceCode?: Maybe<Scalars['String']['output']>;
};

export type EntityDuplicateError = Error & {
  __typename?: 'EntityDuplicateError';
  columns: Scalars['Any']['output'];
  entity: Scalars['String']['output'];
  message: Scalars['String']['output'];
  /**
   * Unique code representing a request intended and generally attached to error objects. Use for user technical
   * support
   */
  referenceCode?: Maybe<Scalars['String']['output']>;
  referenceId: Scalars['String']['output'];
};

export type EntityLockedError = Error & {
  __typename?: 'EntityLockedError';
  entity: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  message: Scalars['String']['output'];
  /**
   * Unique code representing a request intended and generally attached to error objects. Use for user technical
   * support
   */
  referenceCode?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type EntityLockedResult = {
  __typename?: 'EntityLockedResult';
  entity: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type EntityNotFoundError = Error & {
  __typename?: 'EntityNotFoundError';
  entity?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  message: Scalars['String']['output'];
  /**
   * Unique code representing a request intended and generally attached to error objects. Use for user technical
   * support
   */
  referenceCode?: Maybe<Scalars['String']['output']>;
};

export type Error = {
  message: Scalars['String']['output'];
};

export type ErrorDetail = {
  __typename?: 'ErrorDetail';
  fieldName: Scalars['String']['output'];
  messages: Array<Scalars['String']['output']>;
};

export type ExpirePersonError = EntityLockedError | EntityNotFoundError | UnknownError | ValidationError;

export type ExpirePersonInput = {
  id: Scalars['UUID']['input'];
};

export type ExpirePersonPayload = {
  __typename?: 'ExpirePersonPayload';
  errors?: Maybe<Array<ExpirePersonError>>;
  person?: Maybe<Person>;
};

export type ExpireStudentError = EntityLockedError | EntityNotFoundError | UnknownError | ValidationError;

export type ExpireStudentInput = {
  id: Scalars['UUID']['input'];
};

export type ExpireStudentPayload = {
  __typename?: 'ExpireStudentPayload';
  errors?: Maybe<Array<ExpireStudentError>>;
  student?: Maybe<Student>;
};

export type File = {
  __typename?: 'File';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  blobName?: Maybe<Scalars['String']['output']>;
  blurHash?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  fileHash?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  fileSize: Scalars['Long']['output'];
  formats?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  mimeType?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  storageAccount?: Maybe<Scalars['String']['output']>;
  storageContainer?: Maybe<Scalars['String']['output']>;
  studentFiles: Array<StudentFile>;
  triageFiles: Array<TriageFile>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  weeklyReportFiles: Array<WeeklyReportFile>;
};

export type FileSortInput = {
  archivedAt?: InputMaybe<SortEnumType>;
  blobName?: InputMaybe<SortEnumType>;
  blurHash?: InputMaybe<SortEnumType>;
  category?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  deletedAt?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  displayName?: InputMaybe<SortEnumType>;
  fileHash?: InputMaybe<SortEnumType>;
  fileName?: InputMaybe<SortEnumType>;
  fileSize?: InputMaybe<SortEnumType>;
  formats?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  mimeType?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  storageAccount?: InputMaybe<SortEnumType>;
  storageContainer?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

export type Flag = {
  __typename?: 'Flag';
  answerFlags: Array<AnswerFlag>;
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  companyTopFlags: Array<CompanyTopFlag>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  questionFlags: Array<QuestionFlag>;
  status?: Maybe<Scalars['String']['output']>;
  traitFlags: Array<TraitFlag>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type FlagDto = {
  __typename?: 'FlagDTO';
  answerFlags: Array<AnswerFlagDto>;
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  companyTopFlags: Array<CompanyTopFlagDto>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  questionFlags: Array<QuestionFlagDto>;
  status?: Maybe<Scalars['String']['output']>;
  traitFlag: Array<TraitFlagDto>;
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type FlagRankingDto = {
  __typename?: 'FlagRankingDTO';
  flagId: Scalars['UUID']['output'];
  flagTitle: Scalars['String']['output'];
  rankings: Array<RankingItemDto>;
};

export enum GroupingType {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type History = {
  __typename?: 'History';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  data: Scalars['Any']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  historyCompanys: Array<HistoryCompany>;
  historyPersons: Array<HistoryPerson>;
  historyStudents: Array<HistoryStudent>;
  historyWorkLists: Array<HistoryWorkList>;
  id: Scalars['UUID']['output'];
  locationId: Scalars['UUID']['output'];
  personId: Scalars['UUID']['output'];
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type HistoryCompany = {
  __typename?: 'HistoryCompany';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  company?: Maybe<Company>;
  companyId: Scalars['UUID']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  history?: Maybe<History>;
  historyId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type HistoryCompanyDto = {
  __typename?: 'HistoryCompanyDTO';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  company?: Maybe<CompanyDto>;
  companyId: Scalars['UUID']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  history?: Maybe<HistoryDto>;
  historyId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type HistoryDto = {
  __typename?: 'HistoryDTO';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  data?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  historyCompany: Array<HistoryCompanyDto>;
  historyPersons: Array<HistoryPersonDto>;
  historyStudents: Array<HistoryStudentDto>;
  historyWorkLists: Array<HistoryWorkListDto>;
  id: Scalars['UUID']['output'];
  locationId: Scalars['UUID']['output'];
  personId: Scalars['UUID']['output'];
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type HistoryPerson = {
  __typename?: 'HistoryPerson';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  history?: Maybe<History>;
  historyId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  person?: Maybe<Person>;
  personId: Scalars['UUID']['output'];
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type HistoryPersonDto = {
  __typename?: 'HistoryPersonDTO';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  history?: Maybe<HistoryDto>;
  historyId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  person?: Maybe<PersonDto>;
  personId: Scalars['UUID']['output'];
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type HistorySessionDto = {
  __typename?: 'HistorySessionDTO';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  history?: Maybe<HistoryDto>;
  historyId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  session?: Maybe<SessionDto>;
  sessionId: Scalars['UUID']['output'];
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type HistorySortInput = {
  archivedAt?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  data?: InputMaybe<SortEnumType>;
  deletedAt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  locationId?: InputMaybe<SortEnumType>;
  personId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

export type HistoryStudent = {
  __typename?: 'HistoryStudent';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  history?: Maybe<History>;
  historyId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  status?: Maybe<Scalars['String']['output']>;
  student?: Maybe<Student>;
  studentId: Scalars['UUID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type HistoryStudentDto = {
  __typename?: 'HistoryStudentDTO';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  history?: Maybe<HistoryDto>;
  historyId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  status?: Maybe<Scalars['String']['output']>;
  student?: Maybe<StudentDto>;
  studentId: Scalars['UUID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type HistoryWorkList = {
  __typename?: 'HistoryWorkList';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  history?: Maybe<History>;
  historyId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  workList?: Maybe<WorkList>;
  workListId: Scalars['UUID']['output'];
};

export type HistoryWorkListDto = {
  __typename?: 'HistoryWorkListDTO';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  history?: Maybe<HistoryDto>;
  historyId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  workList?: Maybe<WorkListDto>;
  workListId: Scalars['UUID']['output'];
};

export type InvalidCustomField = {
  __typename?: 'InvalidCustomField';
  ids?: Maybe<Array<Scalars['UUID']['output']>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type KeyValuePairOfGuidAndQuestionMapDataDto = {
  __typename?: 'KeyValuePairOfGuidAndQuestionMapDataDTO';
  key: Scalars['UUID']['output'];
  value: QuestionMapDataDto;
};

export type KeyValuePairOfStringAndQuestionMapData = {
  __typename?: 'KeyValuePairOfStringAndQuestionMapData';
  key: Scalars['String']['output'];
  value: QuestionMapData;
};

export type Keyword = {
  __typename?: 'Keyword';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  keywordCategories: Array<KeywordCategory>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  wordOrPhrase?: Maybe<Scalars['String']['output']>;
};

export type KeywordCategory = {
  __typename?: 'KeywordCategory';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  category?: Maybe<Category>;
  categoryId: Scalars['UUID']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  keyword?: Maybe<Keyword>;
  keywordId: Scalars['UUID']['output'];
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type KeywordCategoryDto = {
  __typename?: 'KeywordCategoryDTO';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  category?: Maybe<CategoryDto>;
  categoryId: Scalars['UUID']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  keyword?: Maybe<KeywordDto>;
  keywordId: Scalars['UUID']['output'];
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type KeywordDto = {
  __typename?: 'KeywordDTO';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  categoryTypes: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  keywordCategories: Array<KeywordCategoryDto>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  wordOrPhrase: Scalars['String']['output'];
};

export type Location = {
  __typename?: 'Location';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  company: Company;
  companyId: Scalars['UUID']['output'];
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customFields: Array<CustomField>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  demoStudent?: Maybe<Student>;
  description?: Maybe<Scalars['String']['output']>;
  files: Array<File>;
  id: Scalars['UUID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  persons?: Maybe<PersonsConnection>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  streetLineOne?: Maybe<Scalars['String']['output']>;
  streetLineTwo?: Maybe<Scalars['String']['output']>;
  students?: Maybe<StudentsConnection>;
  totalStaff: Scalars['Int']['output'];
  totalStudents: Scalars['Int']['output'];
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updaterId?: Maybe<Scalars['UUID']['output']>;
};


export type LocationPersonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PersonStatus>;
};


export type LocationStudentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type LocationDto = {
  __typename?: 'LocationDTO';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  company?: Maybe<CompanyDto>;
  companyId: Scalars['UUID']['output'];
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  streetLineOne?: Maybe<Scalars['String']['output']>;
  streetLineTwo?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updaterId?: Maybe<Scalars['UUID']['output']>;
};

export type LocationPerson = {
  __typename?: 'LocationPerson';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  location: Location;
  locationId: Scalars['UUID']['output'];
  person: Person;
  personId: Scalars['UUID']['output'];
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LocationPersonDto = {
  __typename?: 'LocationPersonDTO';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  location?: Maybe<LocationDto>;
  locationId: Scalars['UUID']['output'];
  person?: Maybe<PersonDto>;
  personId: Scalars['UUID']['output'];
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LocationSortInput = {
  archivedAt?: InputMaybe<SortEnumType>;
  city?: InputMaybe<SortEnumType>;
  company?: InputMaybe<CompanySortInput>;
  companyId?: InputMaybe<SortEnumType>;
  country?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  deletedAt?: InputMaybe<SortEnumType>;
  demoStudent?: InputMaybe<StudentSortInput>;
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  postalCode?: InputMaybe<SortEnumType>;
  state?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  streetLineOne?: InputMaybe<SortEnumType>;
  streetLineTwo?: InputMaybe<SortEnumType>;
  totalStaff?: InputMaybe<SortEnumType>;
  totalStudents?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updaterId?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type LocationStudentsConnection = {
  __typename?: 'LocationStudentsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<LocationStudentsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Student>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LocationStudentsEdge = {
  __typename?: 'LocationStudentsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Student;
};

/** A connection to a list of items. */
export type LocationsByCompanyIdConnection = {
  __typename?: 'LocationsByCompanyIdConnection';
  /** A list of edges. */
  edges?: Maybe<Array<LocationsByCompanyIdEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Location>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LocationsByCompanyIdEdge = {
  __typename?: 'LocationsByCompanyIdEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Location;
};

/** A connection to a list of items. */
export type LocationsConnection = {
  __typename?: 'LocationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<LocationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Location>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LocationsEdge = {
  __typename?: 'LocationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Location;
};

export type MarkWorkListAsReadError = EntityNotFoundError | UnknownError | ValidationError;

export type MarkWorkListAsReadInput = {
  id: Scalars['UUID']['input'];
};

export type MarkWorkListAsReadPayload = {
  __typename?: 'MarkWorkListAsReadPayload';
  errors?: Maybe<Array<MarkWorkListAsReadError>>;
  workList?: Maybe<WorkList>;
};

export type MarkWorkListResult = {
  __typename?: 'MarkWorkListResult';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Add answer to Question */
  addAnswer: AnswerResult;
  /** Create adventure avatar */
  addAvatar: AvatarResult;
  addCompany: AddCompanyPayload;
  /** Add a new subscription to a company */
  addCompanySubscription: AddCompanySubscriptionPayload;
  /** Create new customfield for a location */
  addCustomField: CustomField;
  /** Add Location */
  addLocation: AddLocationPayload;
  /**
   * Add a new person to a company location.
   * Note: company and location ID is specified in the request headers.
   */
  addPerson: AddPersonPayload;
  /** Add note to session */
  addSessionNote: AddSessionNotePayload;
  /** Create new student */
  addStudent: AddStudentPayload;
  /** Add note to Student */
  addStudentNote: AddStudentNotePayload;
  addWorkList: AddWorkListPayload;
  /**
   * Create work lists for teachers associated with a student. Mutation can only be used
   * once a session has a status of Pending.
   */
  addWorkLists: WorkListResult;
  /** Assign students to a person */
  assignLocationPersons: AssignLocationPersonsPayload;
  /** Assign students to a person */
  assignPersonLocations: AssignPersonLocationsPayload;
  /** Assign students to a person */
  assignPersonStudents: AssignPersonStudentsPayload;
  /** Assigns persons to a student */
  assignStudentPersons: AssignStudentPersonsPayload;
  authenticate: AuthenticationResult;
  /** Start a session with checkpoint type "Initialized" */
  beginSession: BeginSessionPayload;
  /** Stop session and set checkpoint to "AppClosed" */
  closeSession: CloseSessionPayload;
  /** Edit existing company */
  editCompany: EditCompanyPayload;
  /** Edit Location */
  editLocation: EditLocationPayload;
  /** Assigns students to a location */
  editLocationStudents: EditLocationStudentsPayload;
  /**
   * Edit existing person account
   * Note: company and location ID is specified in the request headers.
   */
  editPerson: EditPersonPayload;
  editSession: EditSessionPayload;
  /** Edit existing student */
  editStudent: EditStudentPayload;
  /** Edit the student's parent's email */
  editStudentChildEmail: EditStudentChildEmailPayload;
  /** Edit the student's parent's email */
  editStudentLocation: EditStudentLocationPayload;
  /** Edit the student's parent's email */
  editStudentParentEmail: EditStudentParentEmailPayload;
  /**
   * Expire person account
   * Note: company and location ID is specified in the request headers.
   */
  expirePerson: ExpirePersonPayload;
  /** Expire student record */
  expireStudent: ExpireStudentPayload;
  /** Change the worklist status to "Read" */
  markWorkListAsRead: MarkWorkListAsReadPayload;
  /** Edit the student's parental consent */
  parentalConsentResponse: ParentalConsentResponsePayload;
  /** Renew subscription to a company */
  renewCompanySubscription: RenewCompanySubscriptionPayload;
  /** Set the current/default location for a signed in user */
  setDefaultLocation: SetDefaultLocationPayload;
  /**
   * Advance a session checkpoint and log details. Some checkpoints
   * Advance checkpoint and log details for each checkpoint shifted.
   */
  shiftSessionCheckpoint: ShiftSessionCheckpointPayload;
  /** Assigns student to a enw locaiton and rmeoves people from olds */
  transferStudentLocation: TransferStudentLocationPayload;
  /** Remove student assignments from a person */
  unassignLocationPersons: UnassignLocationPersonsPayload;
  /** Remove student assignments from a person */
  unassignPersonLocations: UnassignPersonLocationsPayload;
  /** Remove student assignments from a person */
  unassignPersonStudents: UnassignPersonStudentsPayload;
  /** Unassign persons from student */
  unassignStudentPersons: UnassignStudentPersonsPayload;
  verifyPassword: Scalars['Boolean']['output'];
};


export type MutationAddAnswerArgs = {
  input: AddAnswerInput;
};


export type MutationAddAvatarArgs = {
  input: AddAvatarInput;
};


export type MutationAddCompanyArgs = {
  input: AddCompanyInput;
};


export type MutationAddCompanySubscriptionArgs = {
  input: AddCompanySubscriptionInput;
};


export type MutationAddCustomFieldArgs = {
  input: AddCustomFieldInput;
};


export type MutationAddLocationArgs = {
  input: AddLocationInput;
};


export type MutationAddPersonArgs = {
  input: AddPersonInput;
};


export type MutationAddSessionNoteArgs = {
  input: AddSessionNoteInput;
};


export type MutationAddStudentArgs = {
  input: AddStudentInput;
};


export type MutationAddStudentNoteArgs = {
  input: AddStudentNoteInput;
};


export type MutationAddWorkListArgs = {
  input: AddWorkListInput;
};


export type MutationAddWorkListsArgs = {
  input: AddWorkListsInput;
};


export type MutationAssignLocationPersonsArgs = {
  input: AssignLocationPersonsInput;
};


export type MutationAssignPersonLocationsArgs = {
  input: AssignPersonLocationsInput;
};


export type MutationAssignPersonStudentsArgs = {
  input: AssignPersonStudentsInput;
};


export type MutationAssignStudentPersonsArgs = {
  input: AssignStudentPersonsInput;
};


export type MutationAuthenticateArgs = {
  input: AuthenticateInput;
};


export type MutationBeginSessionArgs = {
  input: BeginSessionInput;
};


export type MutationCloseSessionArgs = {
  input: CloseSessionInput;
};


export type MutationEditCompanyArgs = {
  input: EditCompanyInput;
};


export type MutationEditLocationArgs = {
  input: EditLocationInput;
};


export type MutationEditLocationStudentsArgs = {
  input: EditLocationStudentsInput;
};


export type MutationEditPersonArgs = {
  input: EditPersonInput;
};


export type MutationEditSessionArgs = {
  input: EditSessionInput;
};


export type MutationEditStudentArgs = {
  input: EditStudentInput;
};


export type MutationEditStudentChildEmailArgs = {
  input: EditStudentChildEmailInput;
};


export type MutationEditStudentLocationArgs = {
  input: EditStudentLocationInput;
};


export type MutationEditStudentParentEmailArgs = {
  input: EditStudentParentEmailInput;
};


export type MutationExpirePersonArgs = {
  input: ExpirePersonInput;
};


export type MutationExpireStudentArgs = {
  input: ExpireStudentInput;
};


export type MutationMarkWorkListAsReadArgs = {
  input: MarkWorkListAsReadInput;
};


export type MutationParentalConsentResponseArgs = {
  input: ParentalConsentResponseInput;
};


export type MutationRenewCompanySubscriptionArgs = {
  input: RenewCompanySubscriptionInput;
};


export type MutationSetDefaultLocationArgs = {
  input: SetDefaultLocationInput;
};


export type MutationShiftSessionCheckpointArgs = {
  input: ShiftSessionCheckpointInput;
};


export type MutationTransferStudentLocationArgs = {
  input: TransferStudentLocationInput;
};


export type MutationUnassignLocationPersonsArgs = {
  input: UnassignLocationPersonsInput;
};


export type MutationUnassignPersonLocationsArgs = {
  input: UnassignPersonLocationsInput;
};


export type MutationUnassignPersonStudentsArgs = {
  input: UnassignPersonStudentsInput;
};


export type MutationUnassignStudentPersonsArgs = {
  input: UnassignStudentPersonsInput;
};


export type MutationVerifyPasswordArgs = {
  input: VerifyPasswordInput;
};

export type NotFoundErrorResult = {
  __typename?: 'NotFoundErrorResult';
  entity: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type Note = {
  __typename?: 'Note';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  data?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  origin?: Maybe<Scalars['String']['output']>;
  person: Person;
  sessionNotes: Array<SessionNote>;
  status?: Maybe<Scalars['String']['output']>;
  studentNotes: Array<StudentNote>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  workListId: Scalars['UUID']['output'];
  workListNotes: Array<WorkListNote>;
};

export type NoteDto = {
  __typename?: 'NoteDTO';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  data?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  origin?: Maybe<Scalars['String']['output']>;
  personId?: Maybe<Scalars['UUID']['output']>;
  sessionNotes: Array<SessionNoteDto>;
  status?: Maybe<Scalars['String']['output']>;
  studentNotes: Array<StudentNoteDto>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  workListNotes: Array<WorkListNoteDto>;
};

export enum NoteOriginType {
  Backend = 'BACKEND',
  HistoryTable = 'HISTORY_TABLE',
  NotesTable = 'NOTES_TABLE',
  ResultsTable = 'RESULTS_TABLE',
  StudentTable = 'STUDENT_TABLE'
}

export enum NoteTypeEnum {
  Default = 'DEFAULT',
  EnligntnDocSent = 'ENLIGNTN_DOC_SENT',
  General = 'GENERAL',
  Monitoring = 'MONITORING',
  NoReferral = 'NO_REFERRAL',
  ParentConsentRequested = 'PARENT_CONSENT_REQUESTED',
  ParentConsentResponseReceived = 'PARENT_CONSENT_RESPONSE_RECEIVED',
  ParentGeneralInformationSent = 'PARENT_GENERAL_INFORMATION_SENT',
  ParentReportSent = 'PARENT_REPORT_SENT',
  Referral = 'REFERRAL',
  SessionNote = 'SESSION_NOTE'
}

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** Indicates whether more edges exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean']['output'];
  /** Indicates whether more edges exist prior the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type ParentalConsentResponseError = EntityNotFoundError | UnknownError | ValidationError;

export type ParentalConsentResponseInput = {
  id: Scalars['UUID']['input'];
  response: ParentalConsentType;
};

export type ParentalConsentResponsePayload = {
  __typename?: 'ParentalConsentResponsePayload';
  errors?: Maybe<Array<ParentalConsentResponseError>>;
  student?: Maybe<Student>;
};

export enum ParentalConsentType {
  Given = 'GIVEN',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Timelapsed = 'TIMELAPSED'
}

/** A connection to a list of items. */
export type PeopleConnection = {
  __typename?: 'PeopleConnection';
  /** A list of edges. */
  edges?: Maybe<Array<PeopleEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Person>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PeopleEdge = {
  __typename?: 'PeopleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Person;
};

export type Person = {
  __typename?: 'Person';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  company: Company;
  companyId: Scalars['UUID']['output'];
  createdAt: Scalars['DateTime']['output'];
  dashboardStats: DashboardStats;
  defaultLocation?: Maybe<Location>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  dob?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   * For convenience this calculated field is the result of if the student is
   * archived, or has the status "Expired"
   */
  expired: Scalars['Boolean']['output'];
  firstName: Scalars['String']['output'];
  history: Array<History>;
  historyPersons: Array<HistoryPerson>;
  id: Scalars['UUID']['output'];
  jobTitle?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  lastRunSession: Scalars['DateTime']['output'];
  locationPersons: Array<LocationPerson>;
  locationStudents?: Maybe<LocationStudentsConnection>;
  locations?: Maybe<LocationsConnection>;
  middleName?: Maybe<Scalars['String']['output']>;
  personStudents: Array<PersonStudent>;
  role?: Maybe<Role>;
  sessions: Array<Session>;
  singleStudents: Array<Student>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  students?: Maybe<StudentsConnection>;
  totalCompleteSessions: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  workLists: Array<WorkList>;
  worklist?: Maybe<WorkList>;
};


export type PersonLocationStudentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StudentStatus>;
};


export type PersonLocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type PersonSingleStudentsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StudentStatus>;
};


export type PersonStudentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StudentStatus>;
};


export type PersonWorkListsArgs = {
  status?: InputMaybe<WorkListStatus>;
};


export type PersonWorklistArgs = {
  sessionId: Scalars['UUID']['input'];
};

export type PersonDto = {
  __typename?: 'PersonDTO';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  company?: Maybe<CompanyDto>;
  companyId: Scalars['UUID']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  dob?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  firstName: Scalars['String']['output'];
  historyPersons: Array<HistoryPersonDto>;
  id: Scalars['UUID']['output'];
  identityId?: Maybe<Scalars['String']['output']>;
  identityType?: Maybe<Scalars['String']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  locationPersons: Array<LocationPersonDto>;
  middleName?: Maybe<Scalars['String']['output']>;
  sessions?: Maybe<Array<SessionDto>>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  workLists?: Maybe<Array<WorkListDto>>;
};

export enum PersonRole {
  Developer = 'DEVELOPER',
  EducationAdmin = 'EDUCATION_ADMIN',
  EducationStandard = 'EDUCATION_STANDARD',
  EducationSuper = 'EDUCATION_SUPER',
  MedicalAdmin = 'MEDICAL_ADMIN',
  MedicalStandard = 'MEDICAL_STANDARD',
  MedicalSuper = 'MEDICAL_SUPER',
  SupportAdmin = 'SUPPORT_ADMIN'
}

export type PersonSortInput = {
  archivedAt?: InputMaybe<SortEnumType>;
  company?: InputMaybe<CompanySortInput>;
  companyId?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  defaultLocation?: InputMaybe<LocationSortInput>;
  deletedAt?: InputMaybe<SortEnumType>;
  dob?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  endDate?: InputMaybe<SortEnumType>;
  /**
   * For convenience this calculated field is the result of if the student is
   * archived, or has the status "Expired"
   */
  expired?: InputMaybe<SortEnumType>;
  firstName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  jobTitle?: InputMaybe<SortEnumType>;
  lastName?: InputMaybe<SortEnumType>;
  middleName?: InputMaybe<SortEnumType>;
  role?: InputMaybe<RoleSortInput>;
  startDate?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type PersonStatsPerCompanyConnection = {
  __typename?: 'PersonStatsPerCompanyConnection';
  /** A list of edges. */
  edges?: Maybe<Array<PersonStatsPerCompanyEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Person>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PersonStatsPerCompanyEdge = {
  __typename?: 'PersonStatsPerCompanyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Person;
};

export enum PersonStatus {
  Active = 'ACTIVE',
  All = 'ALL',
  Archived = 'ARCHIVED',
  Expired = 'EXPIRED'
}

export type PersonStudent = {
  __typename?: 'PersonStudent';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  person?: Maybe<Person>;
  personId: Scalars['UUID']['output'];
  status?: Maybe<Scalars['String']['output']>;
  student?: Maybe<Student>;
  studentId: Scalars['UUID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** A connection to a list of items. */
export type PersonsConnection = {
  __typename?: 'PersonsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<PersonsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Person>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PersonsEdge = {
  __typename?: 'PersonsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Person;
};

export type PreviousSession = {
  __typename?: 'PreviousSession';
  ageInDays: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  status?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  adventure?: Maybe<Adventure>;
  adventures: Array<Adventure>;
  allCustomFields: Array<CustomField>;
  allQuestions: Array<Question>;
  allSessionForGlobal: Array<Session>;
  answer: Answer;
  answersByCondition?: Maybe<AnswersByConditionConnection>;
  authTest: Scalars['String']['output'];
  avatar: Avatar;
  avatars: Array<Avatar>;
  companies?: Maybe<CompaniesConnection>;
  company?: Maybe<Company>;
  companySubscription?: Maybe<CompanySubscription>;
  companySubscriptions?: Maybe<CompanySubscriptionsConnection>;
  customField?: Maybe<CustomField>;
  customFields: Array<CustomField>;
  keywordAnswersForSession: Array<Answer>;
  keywords: Array<Keyword>;
  location?: Maybe<Location>;
  locations: Array<Location>;
  locationsByCompanyId?: Maybe<LocationsByCompanyIdConnection>;
  me?: Maybe<Person>;
  mySessions: Array<Session>;
  people?: Maybe<PeopleConnection>;
  person: Person;
  personStatsPerCompany?: Maybe<PersonStatsPerCompanyConnection>;
  persons: Array<Person>;
  question?: Maybe<Question>;
  questionContingent: QuestionContingent;
  questionContingents: Array<QuestionContingent>;
  questions: Array<Question>;
  roles: Array<Role>;
  scene: Scene;
  scenes: Array<Scene>;
  session: Session;
  sessionStatusType: TestType;
  sessions: Array<Session>;
  sessionsByCondition?: Maybe<SessionsByConditionConnection>;
  sessionsByFrequency: Array<SessionGroupType>;
  student: Student;
  students?: Maybe<StudentsConnection>;
  subscriptions: Array<Subscription>;
  workList: WorkList;
  workLists: Array<WorkList>;
};


export type QueryAdventureArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryAllSessionForGlobalArgs = {
  status?: InputMaybe<SessionStatus>;
};


export type QueryAnswerArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryAnswersByConditionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  answerGroup?: InputMaybe<AnswerGroup>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  searchCriteria: Scalars['String']['input'];
  searchId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryAvatarArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryAvatarsArgs = {
  order?: InputMaybe<Array<AvatarSortInput>>;
};


export type QueryCompaniesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCompanyArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryCompanySubscriptionArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryCompanySubscriptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['UUID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCustomFieldArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryCustomFieldsArgs = {
  locationId: Scalars['UUID']['input'];
};


export type QueryKeywordAnswersForSessionArgs = {
  sessionId: Scalars['UUID']['input'];
};


export type QueryKeywordsArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLocationArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryLocationsByCompanyIdArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['UUID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPeopleArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['UUID']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PersonStatus>;
};


export type QueryPersonArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryPersonStatsPerCompanyArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['UUID']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PersonStatus>;
};


export type QueryPersonsArgs = {
  role?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PersonStatus>;
};


export type QueryQuestionArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryQuestionContingentArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryQuestionsArgs = {
  input: QuestionParamInput;
};


export type QueryRolesArgs = {
  companyType: Scalars['String']['input'];
};


export type QuerySceneArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryScenesArgs = {
  adventureId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QuerySessionArgs = {
  id: Scalars['UUID']['input'];
};


export type QuerySessionStatusTypeArgs = {
  status: SessionStatus;
};


export type QuerySessionsArgs = {
  locationId: Scalars['UUID']['input'];
  status?: InputMaybe<SessionStatus>;
};


export type QuerySessionsByConditionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchCriteria: Scalars['String']['input'];
  searchId?: InputMaybe<Scalars['UUID']['input']>;
  sessionType?: InputMaybe<SessionScreenType>;
};


export type QuerySessionsByFrequencyArgs = {
  frequency: GroupingType;
  searchCriteria: Scalars['String']['input'];
  searchId?: InputMaybe<Scalars['UUID']['input']>;
  sessionType?: InputMaybe<SessionScreenType>;
};


export type QueryStudentArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryStudentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  origin?: InputMaybe<QueryOrigin>;
  query?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StudentStatus>;
};


export type QueryWorkListArgs = {
  id: Scalars['UUID']['input'];
};

export enum QueryOrigin {
  Dashboard = 'DASHBOARD',
  Manage = 'MANAGE',
  Pending = 'PENDING'
}

export type Question = {
  __typename?: 'Question';
  adventures: Array<Adventure>;
  answerFlags: Array<AnswerFlag>;
  answers: Array<Answer>;
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  companyTopFlags: Array<CompanyTopFlag>;
  createdAt: Scalars['DateTime']['output'];
  data?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  language?: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
  questionContingents: Array<QuestionContingent>;
  questionFlags: Array<QuestionFlag>;
  questionParentContingents: Array<QuestionContingent>;
  questionSet?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum QuestionCategoryType {
  Environment = 'ENVIRONMENT',
  Personal = 'PERSONAL',
  Survey = 'SURVEY'
}

export type QuestionContingent = {
  __typename?: 'QuestionContingent';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  parentId: Scalars['UUID']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  question: Question;
  questionId: Scalars['UUID']['output'];
  questionParent: Question;
  rule?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type QuestionContingentDto = {
  __typename?: 'QuestionContingentDTO';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  parentId: Scalars['UUID']['output'];
  question?: Maybe<QuestionDto>;
  questionId: Scalars['UUID']['output'];
  questionParent?: Maybe<QuestionDto>;
  rule?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type QuestionDto = {
  __typename?: 'QuestionDTO';
  answerFlags: Array<AnswerFlagDto>;
  answers: Array<AnswerDto>;
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  companyTopFlags: Array<CompanyTopFlagDto>;
  createdAt: Scalars['DateTime']['output'];
  data?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  language?: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
  questionContingents: Array<QuestionContingentDto>;
  questionFlags: Array<QuestionFlagDto>;
  questionParentContingents: Array<QuestionContingentDto>;
  questionSet?: Maybe<Scalars['String']['output']>;
  sceneQuestions: Array<SceneQuestionDto>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type QuestionFlag = {
  __typename?: 'QuestionFlag';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  flag?: Maybe<Flag>;
  flagId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  question?: Maybe<Question>;
  questionId: Scalars['UUID']['output'];
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type QuestionFlagDto = {
  __typename?: 'QuestionFlagDTO';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  flag?: Maybe<FlagDto>;
  flagId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  question?: Maybe<QuestionDto>;
  questionId: Scalars['UUID']['output'];
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum QuestionLanguageType {
  English = 'ENGLISH',
  Spanish = 'SPANISH'
}

export type QuestionMapData = {
  __typename?: 'QuestionMapData';
  hits: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type QuestionMapDataDto = {
  __typename?: 'QuestionMapDataDTO';
  hits: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type QuestionParamInput = {
  category?: InputMaybe<QuestionCategoryType>;
  language?: InputMaybe<QuestionLanguageType>;
  questionSet: QuestionScreenType;
};

export enum QuestionScreenType {
  TweenScreen = 'TWEEN_SCREEN',
  TScreen = 'T_SCREEN'
}

export type RankingItemDto = {
  __typename?: 'RankingItemDTO';
  label: Scalars['String']['output'];
  rank: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type RenewCompanySubscriptionError = EntityNotFoundError | UnknownError | ValidationError;

export type RenewCompanySubscriptionInput = {
  companySubscriptionId: Scalars['UUID']['input'];
};

export type RenewCompanySubscriptionPayload = {
  __typename?: 'RenewCompanySubscriptionPayload';
  companySubscription?: Maybe<CompanySubscription>;
  errors?: Maybe<Array<RenewCompanySubscriptionError>>;
};

export type Role = {
  __typename?: 'Role';
  clientFacingName: Scalars['String']['output'];
  default: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  normalizedName: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
};

export type RoleSortInput = {
  clientFacingName?: InputMaybe<SortEnumType>;
  default?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  normalizedName?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
};

export type Scene = {
  __typename?: 'Scene';
  adventure: Adventure;
  adventureId: Scalars['UUID']['output'];
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
  questions: Array<Question>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SceneDto = {
  __typename?: 'SceneDTO';
  adventure?: Maybe<AdventureDto>;
  adventureId: Scalars['UUID']['output'];
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
  sceneQuestions: Array<SceneQuestionDto>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SceneQuestionDto = {
  __typename?: 'SceneQuestionDTO';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  question?: Maybe<QuestionDto>;
  questionId: Scalars['UUID']['output'];
  scene?: Maybe<SceneDto>;
  sceneId: Scalars['UUID']['output'];
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type Session = {
  __typename?: 'Session';
  activeTimeInSurvey: Scalars['String']['output'];
  adventure?: Maybe<Adventure>;
  adventureId?: Maybe<Scalars['UUID']['output']>;
  answers?: Maybe<Array<Answer>>;
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  avatar?: Maybe<Avatar>;
  avatarId?: Maybe<Scalars['UUID']['output']>;
  category: Scalars['String']['output'];
  checkpoint?: Maybe<SessionCheckpoint>;
  code?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  data?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  deviceAndBrowser?: Maybe<Scalars['String']['output']>;
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  hasKeyWords: Scalars['Boolean']['output'];
  history: Array<History>;
  id: Scalars['UUID']['output'];
  language: Scalars['String']['output'];
  launchPerson: Person;
  launchPersonId: Scalars['UUID']['output'];
  location: Location;
  locationId: Scalars['UUID']['output'];
  notes: Array<Note>;
  person: Person;
  personId: Scalars['UUID']['output'];
  report: Array<File>;
  result?: Maybe<SessionResult>;
  riskRating: Scalars['Int']['output'];
  status?: Maybe<Scalars['String']['output']>;
  student: Student;
  studentId: Scalars['UUID']['output'];
  summary?: Maybe<SessionSummary>;
  totalTimeSpent: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  workLists: Array<WorkList>;
  worklist?: Maybe<WorkList>;
};

export type SessionAlreadyClosedError = {
  __typename?: 'SessionAlreadyClosedError';
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type SessionAnswerInput = {
  data: Scalars['String']['input'];
  enteredAt: Scalars['DateTime']['input'];
  questionId: Scalars['UUID']['input'];
};

export enum SessionCategoryType {
  Local = 'LOCAL',
  Remote = 'REMOTE'
}

export type SessionCheckpoint = {
  __typename?: 'SessionCheckpoint';
  current?: Maybe<SessionCheckpointDetail>;
  next?: Maybe<SessionCheckpointDetail>;
  values: Array<Scalars['String']['output']>;
};

export type SessionCheckpointDetail = {
  __typename?: 'SessionCheckpointDetail';
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
};

export type SessionCheckpointDetailSortInput = {
  name?: InputMaybe<SortEnumType>;
  position?: InputMaybe<SortEnumType>;
};

export type SessionCheckpointSortInput = {
  current?: InputMaybe<SessionCheckpointDetailSortInput>;
  next?: InputMaybe<SessionCheckpointDetailSortInput>;
};

export type SessionDto = {
  __typename?: 'SessionDTO';
  adventure?: Maybe<AdventureDto>;
  adventureId?: Maybe<Scalars['UUID']['output']>;
  answers: Array<AnswerDto>;
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  avatar?: Maybe<AvatarDto>;
  avatarId?: Maybe<Scalars['UUID']['output']>;
  cameraAccess?: Maybe<Scalars['Boolean']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  checkpoint: Scalars['String']['output'];
  code?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  historySessions: Array<HistorySessionDto>;
  id: Scalars['UUID']['output'];
  language: Scalars['String']['output'];
  launchPersonId: Scalars['UUID']['output'];
  location?: Maybe<LocationDto>;
  locationId: Scalars['UUID']['output'];
  parentReportStatus?: Maybe<Scalars['String']['output']>;
  person?: Maybe<PersonDto>;
  personId: Scalars['UUID']['output'];
  result?: Maybe<SessionResultDto>;
  riskRating: Scalars['Int']['output'];
  sessionLogs: Array<SessionLogDto>;
  sessionNotes: Array<SessionNoteDto>;
  status?: Maybe<Scalars['String']['output']>;
  student?: Maybe<StudentDto>;
  studentId: Scalars['UUID']['output'];
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SessionGroupType = {
  __typename?: 'SessionGroupType';
  day?: Maybe<Scalars['Int']['output']>;
  month?: Maybe<Scalars['Int']['output']>;
  sessions: Array<Session>;
  start: Scalars['DateTime']['output'];
  total: Scalars['Int']['output'];
  week?: Maybe<Scalars['Int']['output']>;
  year: Scalars['Int']['output'];
};

export type SessionLogDto = {
  __typename?: 'SessionLogDTO';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  message: Scalars['String']['output'];
  session?: Maybe<SessionDto>;
  sessionId: Scalars['UUID']['output'];
  status?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SessionNotFoundError = {
  __typename?: 'SessionNotFoundError';
  id?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type SessionNote = {
  __typename?: 'SessionNote';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  note?: Maybe<Note>;
  noteId: Scalars['UUID']['output'];
  session?: Maybe<Session>;
  sessionId: Scalars['UUID']['output'];
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SessionNoteDto = {
  __typename?: 'SessionNoteDTO';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  note?: Maybe<NoteDto>;
  noteId: Scalars['UUID']['output'];
  session?: Maybe<SessionDto>;
  sessionId: Scalars['UUID']['output'];
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SessionResult = {
  __typename?: 'SessionResult';
  assessmentData: AssessmentData;
  questionMap: Array<KeyValuePairOfStringAndQuestionMapData>;
};

export type SessionResultDto = {
  __typename?: 'SessionResultDTO';
  answerFlags: Array<AnswerFlagDto>;
  assessmentData: AssessmentDataDto;
  previousSession: PreviousSession;
  questionMap: Array<KeyValuePairOfGuidAndQuestionMapDataDto>;
};

export type SessionResultSortInput = {
  assessmentData?: InputMaybe<AssessmentDataSortInput>;
};

export enum SessionScreenType {
  All = 'ALL',
  EnglishTweenScreen = 'ENGLISH_TWEEN_SCREEN',
  EnglishTScreen = 'ENGLISH_T_SCREEN'
}

export type SessionSortInput = {
  adventure?: InputMaybe<AdventureSortInput>;
  adventureId?: InputMaybe<SortEnumType>;
  archivedAt?: InputMaybe<SortEnumType>;
  avatar?: InputMaybe<AvatarSortInput>;
  avatarId?: InputMaybe<SortEnumType>;
  category?: InputMaybe<SortEnumType>;
  checkpoint?: InputMaybe<SessionCheckpointSortInput>;
  code?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  data?: InputMaybe<SortEnumType>;
  deletedAt?: InputMaybe<SortEnumType>;
  deviceAndBrowser?: InputMaybe<SortEnumType>;
  file?: InputMaybe<FileSortInput>;
  finishedAt?: InputMaybe<SortEnumType>;
  hasKeyWords?: InputMaybe<SortEnumType>;
  history?: InputMaybe<HistorySortInput>;
  id?: InputMaybe<SortEnumType>;
  language?: InputMaybe<SortEnumType>;
  launchPersonId?: InputMaybe<SortEnumType>;
  location?: InputMaybe<LocationSortInput>;
  locationId?: InputMaybe<SortEnumType>;
  person?: InputMaybe<PersonSortInput>;
  personId?: InputMaybe<SortEnumType>;
  result?: InputMaybe<SessionResultSortInput>;
  riskRating?: InputMaybe<SortEnumType>;
  sessionSummary?: InputMaybe<SessionSummarySortInput>;
  status?: InputMaybe<SortEnumType>;
  student?: InputMaybe<StudentSortInput>;
  studentId?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

export enum SessionStatus {
  /** Return abandoned session */
  Abandoned = 'ABANDONED',
  /** Return completed sessions */
  Complete = 'COMPLETE',
  /** Return incomplete sessions */
  Incomplete = 'INCOMPLETE',
  /** Return pending sessions */
  Pending = 'PENDING'
}

export type SessionSummary = {
  __typename?: 'SessionSummary';
  id: Scalars['UUID']['output'];
  livesMainlyWith?: Maybe<Scalars['String']['output']>;
  livingSituation?: Maybe<Scalars['String']['output']>;
  numberOfSiblings: Scalars['Int']['output'];
  peopleCountedOn: Array<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type SessionSummarySortInput = {
  id?: InputMaybe<SortEnumType>;
  livesMainlyWith?: InputMaybe<SortEnumType>;
  livingSituation?: InputMaybe<SortEnumType>;
  numberOfSiblings?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
};

export enum SessionType {
  Full = 'FULL',
  Partial = 'PARTIAL'
}

/** A connection to a list of items. */
export type SessionsByConditionConnection = {
  __typename?: 'SessionsByConditionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<SessionsByConditionEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Session>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SessionsByConditionEdge = {
  __typename?: 'SessionsByConditionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Session;
};

export type SetDefaultLocationError = EntityNotFoundError | UnknownError | ValidationError;

export type SetDefaultLocationInput = {
  id: Scalars['UUID']['input'];
};

export type SetDefaultLocationPayload = {
  __typename?: 'SetDefaultLocationPayload';
  errors?: Maybe<Array<SetDefaultLocationError>>;
  locationPerson?: Maybe<LocationPerson>;
};

export type ShiftSessionCheckpointError = EntityCompletedError | EntityDuplicateError | EntityNotFoundError | UnknownError | ValidationError;

export type ShiftSessionCheckpointInput = {
  adventureId?: InputMaybe<Scalars['UUID']['input']>;
  answers?: InputMaybe<Array<SessionAnswerInput>>;
  avatarId?: InputMaybe<Scalars['UUID']['input']>;
  cameraAccess?: InputMaybe<Scalars['Boolean']['input']>;
  deviceAndBrowser?: InputMaybe<Scalars['String']['input']>;
  enteredAt: Scalars['DateTime']['input'];
  sessionId: Scalars['UUID']['input'];
  type: CheckpointType;
  usePreviousSession?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ShiftSessionCheckpointPayload = {
  __typename?: 'ShiftSessionCheckpointPayload';
  errors?: Maybe<Array<ShiftSessionCheckpointError>>;
  session?: Maybe<Session>;
};

export enum SortEnumType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type Student = {
  __typename?: 'Student';
  allNotes: Array<Note>;
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  avatar: Avatar;
  avatars: Array<Avatar>;
  consentEmailSentTimes: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  demoStudent: Scalars['Boolean']['output'];
  dob: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   * For convenience this calculated field is the result of if the student is
   * archived, or has the status "Expired"
   */
  expired: Scalars['Boolean']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  gradeLevel?: Maybe<Scalars['Int']['output']>;
  historyStudents?: Maybe<Array<HistoryStudent>>;
  id: Scalars['UUID']['output'];
  lastConsentAction?: Maybe<History>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastSession?: Maybe<Session>;
  location: Location;
  locationId: Scalars['UUID']['output'];
  middleName?: Maybe<Scalars['String']['output']>;
  minimumProvided: Scalars['Boolean']['output'];
  notes: Array<Note>;
  parentEmail?: Maybe<Scalars['String']['output']>;
  parentPhone?: Maybe<Scalars['String']['output']>;
  parentalConsentStatus?: Maybe<Scalars['String']['output']>;
  people?: Maybe<PeopleConnection>;
  persons?: Maybe<PersonsConnection>;
  postalCode?: Maybe<Scalars['String']['output']>;
  references: Scalars['Int']['output'];
  sessions: Array<Session>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  studentCustomFields: Array<StudentCustomField>;
  studentFiles: Array<StudentFile>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updater?: Maybe<Person>;
};


export type StudentPeopleArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type StudentPersonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PersonStatus>;
};


export type StudentSessionsArgs = {
  status?: InputMaybe<Array<InputMaybe<SessionStatus>>>;
};

export type StudentCustomField = {
  __typename?: 'StudentCustomField';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customField?: Maybe<CustomField>;
  customFieldId: Scalars['UUID']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  status?: Maybe<Scalars['String']['output']>;
  student?: Maybe<Student>;
  studentId: Scalars['UUID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type StudentCustomFieldDto = {
  __typename?: 'StudentCustomFieldDTO';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customField?: Maybe<CustomFieldDto>;
  customFieldId: Scalars['UUID']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  status?: Maybe<Scalars['String']['output']>;
  student?: Maybe<StudentDto>;
  studentId: Scalars['UUID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type StudentDto = {
  __typename?: 'StudentDTO';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customFieldPairs?: Maybe<Array<CustomFieldPair>>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  demoStudent: Scalars['Boolean']['output'];
  dob: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  firstName: Scalars['String']['output'];
  gradeLevel?: Maybe<Scalars['Int']['output']>;
  id: Scalars['UUID']['output'];
  lastName: Scalars['String']['output'];
  location: LocationDto;
  locationId: Scalars['UUID']['output'];
  middleName?: Maybe<Scalars['String']['output']>;
  minimumProvided: Scalars['Boolean']['output'];
  parentEmail?: Maybe<Scalars['String']['output']>;
  parentPhone?: Maybe<Scalars['String']['output']>;
  parentalConsentStatus?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['DateTime']['output'];
  status?: Maybe<Scalars['String']['output']>;
  studentCustomFields: Array<StudentCustomFieldDto>;
  studentNotes: Array<StudentNoteDto>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updaterId?: Maybe<Scalars['UUID']['output']>;
};

export type StudentFile = {
  __typename?: 'StudentFile';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  file?: Maybe<File>;
  fileId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  status?: Maybe<Scalars['String']['output']>;
  student?: Maybe<Student>;
  studentId: Scalars['UUID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type StudentNote = {
  __typename?: 'StudentNote';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  note?: Maybe<Note>;
  noteId: Scalars['UUID']['output'];
  status?: Maybe<Scalars['String']['output']>;
  student?: Maybe<Student>;
  studentId: Scalars['UUID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type StudentNoteDto = {
  __typename?: 'StudentNoteDTO';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  note?: Maybe<NoteDto>;
  noteId: Scalars['UUID']['output'];
  status?: Maybe<Scalars['String']['output']>;
  student?: Maybe<StudentDto>;
  studentId: Scalars['UUID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type StudentSortInput = {
  archivedAt?: InputMaybe<SortEnumType>;
  avatar?: InputMaybe<AvatarSortInput>;
  createdAt?: InputMaybe<SortEnumType>;
  deletedAt?: InputMaybe<SortEnumType>;
  demoStudent?: InputMaybe<SortEnumType>;
  dob?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  endDate?: InputMaybe<SortEnumType>;
  /**
   * For convenience this calculated field is the result of if the student is
   * archived, or has the status "Expired"
   */
  expired?: InputMaybe<SortEnumType>;
  firstName?: InputMaybe<SortEnumType>;
  gradeLevel?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastName?: InputMaybe<SortEnumType>;
  lastSession?: InputMaybe<SessionSortInput>;
  location?: InputMaybe<LocationSortInput>;
  locationId?: InputMaybe<SortEnumType>;
  middleName?: InputMaybe<SortEnumType>;
  minimumProvided?: InputMaybe<SortEnumType>;
  parentEmail?: InputMaybe<SortEnumType>;
  parentPhone?: InputMaybe<SortEnumType>;
  parentalConsentStatus?: InputMaybe<SortEnumType>;
  postalCode?: InputMaybe<SortEnumType>;
  references?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  updaterId?: InputMaybe<SortEnumType>;
};

export enum StudentStatus {
  Active = 'ACTIVE',
  All = 'ALL',
  Archived = 'ARCHIVED',
  Expired = 'EXPIRED',
  TeenScreenAge = 'TEEN_SCREEN_AGE',
  TweenScreenAge = 'TWEEN_SCREEN_AGE',
  TScreenAge = 'T_SCREEN_AGE'
}

/** A connection to a list of items. */
export type StudentsConnection = {
  __typename?: 'StudentsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<StudentsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Student>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type StudentsEdge = {
  __typename?: 'StudentsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Student;
};

export type Subscription = {
  __typename?: 'Subscription';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SubscriptionDto = {
  __typename?: 'SubscriptionDTO';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type TestType = {
  __typename?: 'TestType';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type Trait = {
  __typename?: 'Trait';
  answerFlags: Array<AnswerFlag>;
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  companyTopFlags?: Maybe<Array<CompanyTopFlag>>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  familyMember?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  traitFlags?: Maybe<Array<TraitFlag>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type TraitDto = {
  __typename?: 'TraitDTO';
  answerFlags: Array<AnswerFlagDto>;
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  companyTopFlags: Array<CompanyTopFlagDto>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  familyMember: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  status?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  traitFlags: Array<TraitFlagDto>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type TraitFlag = {
  __typename?: 'TraitFlag';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  flag?: Maybe<Flag>;
  flagId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  status?: Maybe<Scalars['String']['output']>;
  trait?: Maybe<Trait>;
  traitId: Scalars['UUID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type TraitFlagDto = {
  __typename?: 'TraitFlagDTO';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  flag?: Maybe<FlagDto>;
  flagId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  status?: Maybe<Scalars['String']['output']>;
  trait?: Maybe<TraitDto>;
  traitId: Scalars['UUID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type TransferStudentLocationError = EntityLockedError | EntityNotFoundError | UnknownError | ValidationError;

export type TransferStudentLocationInput = {
  locationId: Scalars['UUID']['input'];
  personIds: Array<Scalars['UUID']['input']>;
  studentId: Scalars['UUID']['input'];
};

export type TransferStudentLocationPayload = {
  __typename?: 'TransferStudentLocationPayload';
  errors?: Maybe<Array<TransferStudentLocationError>>;
  student?: Maybe<Student>;
};

export type TriageFile = {
  __typename?: 'TriageFile';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customField?: Maybe<CustomField>;
  customFieldId?: Maybe<Scalars['UUID']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  file?: Maybe<File>;
  fileId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  location?: Maybe<Location>;
  locationId: Scalars['UUID']['output'];
  person?: Maybe<Person>;
  personId: Scalars['UUID']['output'];
  searchParam?: Maybe<Scalars['String']['output']>;
  sessionDate?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type UnassignLocationPersonsError = EntityBusinessRuleError | EntityLockedError | EntityNotFoundError | UnknownError | ValidationError;

export type UnassignLocationPersonsInput = {
  locationId: Scalars['UUID']['input'];
  personIds: Array<Scalars['UUID']['input']>;
};

export type UnassignLocationPersonsPayload = {
  __typename?: 'UnassignLocationPersonsPayload';
  errors?: Maybe<Array<UnassignLocationPersonsError>>;
  location?: Maybe<Location>;
};

export type UnassignPersonLocationsError = EntityBusinessRuleError | EntityLockedError | EntityNotFoundError | UnknownError | ValidationError;

export type UnassignPersonLocationsInput = {
  locationIds: Array<Scalars['UUID']['input']>;
  personId: Scalars['UUID']['input'];
};

export type UnassignPersonLocationsPayload = {
  __typename?: 'UnassignPersonLocationsPayload';
  errors?: Maybe<Array<UnassignPersonLocationsError>>;
  person?: Maybe<Person>;
};

export type UnassignPersonStudentsError = EntityBusinessRuleError | EntityLockedError | EntityNotFoundError | UnknownError | ValidationError;

export type UnassignPersonStudentsInput = {
  personId: Scalars['UUID']['input'];
  studentIds: Array<Scalars['UUID']['input']>;
};

export type UnassignPersonStudentsPayload = {
  __typename?: 'UnassignPersonStudentsPayload';
  errors?: Maybe<Array<UnassignPersonStudentsError>>;
  person?: Maybe<Person>;
};

export type UnassignStudentPersonsError = EntityBusinessRuleError | EntityLockedError | EntityNotFoundError | UnknownError | ValidationError;

export type UnassignStudentPersonsInput = {
  personIds: Array<Scalars['UUID']['input']>;
  studentId: Scalars['UUID']['input'];
};

export type UnassignStudentPersonsPayload = {
  __typename?: 'UnassignStudentPersonsPayload';
  errors?: Maybe<Array<UnassignStudentPersonsError>>;
  student?: Maybe<Student>;
};

/** Standard catch all error */
export type UnknownError = Error & {
  __typename?: 'UnknownError';
  message: Scalars['String']['output'];
  /**
   * Unique code representing a request intended and generally attached to error objects. Use for user technical
   * support
   */
  referenceCode?: Maybe<Scalars['String']['output']>;
};

export type UnknownErrorResult = {
  __typename?: 'UnknownErrorResult';
  id: Scalars['UUID']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

/** Used when a user provides data that fails input validation. .e.g, user provides an invalid email. */
export type ValidationError = Error & {
  __typename?: 'ValidationError';
  /** List of offending inputs which failed validation */
  errors: Array<ErrorDetail>;
  /** Message shared to the user */
  message: Scalars['String']['output'];
  /**
   * Unique code representing a request intended and generally attached to error objects. Use for user technical
   * support
   */
  referenceCode?: Maybe<Scalars['String']['output']>;
};

export type VerifyPasswordInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type WeeklyReportFile = {
  __typename?: 'WeeklyReportFile';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  company?: Maybe<Company>;
  companyId: Scalars['UUID']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  file?: Maybe<File>;
  fileId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type WorkList = {
  __typename?: 'WorkList';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  historyWorkLists: Array<HistoryWorkList>;
  id: Scalars['UUID']['output'];
  location?: Maybe<Location>;
  notes: Array<Note>;
  person?: Maybe<Person>;
  session?: Maybe<Session>;
  status?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type WorkListDto = {
  __typename?: 'WorkListDTO';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  historyWorkLists: Array<HistoryWorkListDto>;
  id: Scalars['UUID']['output'];
  locationId: Scalars['UUID']['output'];
  person?: Maybe<PersonDto>;
  personId: Scalars['UUID']['output'];
  session?: Maybe<SessionDto>;
  sessionId: Scalars['UUID']['output'];
  status?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  workListNotes: Array<WorkListNoteDto>;
};

export type WorkListNotFoundError = {
  __typename?: 'WorkListNotFoundError';
  id: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type WorkListNote = {
  __typename?: 'WorkListNote';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  note?: Maybe<Note>;
  noteId: Scalars['UUID']['output'];
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  workList?: Maybe<WorkList>;
  workListId: Scalars['UUID']['output'];
};

export type WorkListNoteDto = {
  __typename?: 'WorkListNoteDTO';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  note?: Maybe<NoteDto>;
  noteId: Scalars['UUID']['output'];
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  workList?: Maybe<WorkListDto>;
  workListId: Scalars['UUID']['output'];
};

export type WorkListResult = MarkWorkListResult | WorkListNotFoundError | WorkListNote | WorkListsAlreadyAddedError | WorkListsCreatedResult | XValidationError;

export enum WorkListStatus {
  Reviewed = 'REVIEWED',
  Unread = 'UNREAD'
}

export type WorkListsAlreadyAddedError = {
  __typename?: 'WorkListsAlreadyAddedError';
  changedAt?: Maybe<Scalars['DateTime']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type WorkListsCreatedResult = {
  __typename?: 'WorkListsCreatedResult';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type XEntityBusinessRuleError = {
  __typename?: 'XEntityBusinessRuleError';
  errors: Array<ErrorDetail>;
  message?: Maybe<Scalars['String']['output']>;
  referenceCode?: Maybe<Scalars['String']['output']>;
};

export type XValidationError = {
  __typename?: 'XValidationError';
  errors: Array<ErrorDetail>;
  message?: Maybe<Scalars['String']['output']>;
  referenceCode?: Maybe<Scalars['String']['output']>;
};

export type SelectedPersonQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SelectedPersonQuery = { __typename?: 'Query', person: (
    { __typename?: 'Person' }
    & { ' $fragmentRefs'?: { 'SelectedPerson_PersonFragment': SelectedPerson_PersonFragment } }
  ) };

export type AddAnswerMutationVariables = Exact<{
  data: Scalars['String']['input'];
  sessionId: Scalars['UUID']['input'];
  questionId: Scalars['UUID']['input'];
}>;


export type AddAnswerMutation = { __typename?: 'Mutation', addAnswer: { __typename: 'Answer' } | { __typename: 'XValidationError' } };

export type AddCustomFieldMutationVariables = Exact<{
  input: AddCustomFieldInput;
}>;


export type AddCustomFieldMutation = { __typename?: 'Mutation', addCustomField: { __typename: 'CustomField' } };

export type MarkReviewedMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type MarkReviewedMutation = { __typename?: 'Mutation', markWorkListAsRead: { __typename: 'MarkWorkListAsReadPayload', workList?: { __typename?: 'WorkList', id: any, status?: string | null } | null } };

export type AddPersonMutationVariables = Exact<{
  firstName: Scalars['String']['input'];
  middleName?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  role: PersonRole;
  companyId?: InputMaybe<Scalars['UUID']['input']>;
  startDate: Scalars['DateTime']['input'];
}>;


export type AddPersonMutation = { __typename?: 'Mutation', addPerson: { __typename: 'AddPersonPayload', person?: { __typename?: 'Person', id: any, companyId: any, firstName: string, lastName: string, createdAt: any, company: { __typename?: 'Company', id: any, createdAt: any } } | null, errors?: Array<{ __typename: 'EntityBusinessRuleError' } | { __typename: 'EntityNotFoundError', id: any, message: string } | { __typename: 'UnknownError', message: string } | { __typename: 'ValidationError', errors: Array<{ __typename?: 'ErrorDetail', fieldName: string, messages: Array<string> }> }> | null } };

export type AssignLocationPersonMutationMutationVariables = Exact<{
  locationId: Scalars['UUID']['input'];
  personIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type AssignLocationPersonMutationMutation = { __typename?: 'Mutation', assignLocationPersons: { __typename?: 'AssignLocationPersonsPayload', location?: { __typename?: 'Location', id: any, totalStaff: number } | null } };

export type AssignPersonLocationsMutationMutationVariables = Exact<{
  personId: Scalars['UUID']['input'];
  locationIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type AssignPersonLocationsMutationMutation = { __typename?: 'Mutation', assignPersonLocations: { __typename?: 'AssignPersonLocationsPayload', person?: { __typename?: 'Person', id: any } | null } };

export type AssignStudentPersonsMutationVariables = Exact<{
  studentId: Scalars['UUID']['input'];
  personIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type AssignStudentPersonsMutation = { __typename?: 'Mutation', assignStudentPersons: { __typename?: 'AssignStudentPersonsPayload', student?: { __typename?: 'Student', id: any } | null } };

export type EditPersonMutationVariables = Exact<{
  input: EditPersonInput;
}>;


export type EditPersonMutation = { __typename?: 'Mutation', editPerson: { __typename: 'EditPersonPayload', person?: { __typename?: 'Person', id: any, firstName: string, jobTitle?: string | null, lastName: string, middleName?: string | null, role?: { __typename?: 'Role', name: string, normalizedName: string } | null } | null, errors?: Array<{ __typename: 'EntityLockedError' } | { __typename: 'EntityNotFoundError' } | { __typename: 'UnknownError' } | { __typename: 'ValidationError', message: string, errors: Array<{ __typename?: 'ErrorDetail', fieldName: string, messages: Array<string> }> }> | null } };

export type ExpirePersonMutationVariables = Exact<{
  personId: Scalars['UUID']['input'];
}>;


export type ExpirePersonMutation = { __typename?: 'Mutation', expirePerson: { __typename: 'ExpirePersonPayload', person?: { __typename?: 'Person', id: any, expired: boolean, endDate?: any | null, updatedAt?: any | null } | null, errors?: Array<{ __typename: 'EntityLockedError', id: any, entity: string, message: string, updatedAt?: any | null } | { __typename: 'EntityNotFoundError' } | { __typename: 'UnknownError', message: string } | { __typename: 'ValidationError', errors: Array<{ __typename?: 'ErrorDetail', fieldName: string, messages: Array<string> }> }> | null } };

export type UnassignLocationPersonMutationMutationVariables = Exact<{
  locationId: Scalars['UUID']['input'];
  personIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type UnassignLocationPersonMutationMutation = { __typename?: 'Mutation', unassignLocationPersons: { __typename?: 'UnassignLocationPersonsPayload', location?: { __typename?: 'Location', id: any } | null } };

export type UnassignPersonLocationsMutationMutationVariables = Exact<{
  personId: Scalars['UUID']['input'];
  locationIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type UnassignPersonLocationsMutationMutation = { __typename?: 'Mutation', unassignPersonLocations: { __typename?: 'UnassignPersonLocationsPayload', person?: { __typename?: 'Person', id: any } | null } };

export type UnassignStudentPersonsMutationVariables = Exact<{
  studentId: Scalars['UUID']['input'];
  personIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type UnassignStudentPersonsMutation = { __typename?: 'Mutation', unassignStudentPersons: { __typename?: 'UnassignStudentPersonsPayload', student?: { __typename?: 'Student', id: any, dob: any, email?: string | null, firstName?: string | null, lastName?: string | null, gradeLevel?: number | null, postalCode?: string | null, middleName?: string | null, studentCustomFields: Array<{ __typename?: 'StudentCustomField', value?: string | null, customField?: { __typename?: 'CustomField', id: any, type?: string | null, name?: string | null } | null }>, sessions: Array<{ __typename?: 'Session', id: any, riskRating: number, status?: string | null, createdAt: any, notes: Array<{ __typename?: 'Note', body?: string | null, id: any, data?: string | null }> }>, persons?: { __typename?: 'PersonsConnection', edges?: Array<{ __typename?: 'PersonsEdge', cursor: string, node: { __typename?: 'Person', firstName: string, lastName: string, id: any, role?: { __typename?: 'Role', name: string, normalizedName: string } | null } }> | null } | null, lastSession?: { __typename?: 'Session', id: any, status?: string | null, checkpoint?: { __typename?: 'SessionCheckpoint', current?: { __typename?: 'SessionCheckpointDetail', name: string } | null } | null, summary?: { __typename?: 'SessionSummary', id: any, livingSituation?: string | null, numberOfSiblings: number, peopleCountedOn: Array<string>, livesMainlyWith?: string | null } | null } | null, avatars: Array<{ __typename?: 'Avatar', id: any, bodyId?: any | null, bodyColor?: string | null, eyeColor?: string | null, hairColor?: string | null, helperId?: any | null, shirtColor?: string | null, pantsColor?: string | null, shoesColor?: string | null }> } | null } };

export type AddStudentMutationVariables = Exact<{
  input: AddStudentInput;
}>;


export type AddStudentMutation = { __typename?: 'Mutation', addStudent: { __typename: 'AddStudentPayload', student?: { __typename?: 'Student', id: any } | null, errors?: Array<{ __typename?: 'EntityNotFoundError' } | { __typename?: 'UnknownError' } | { __typename?: 'ValidationError', message: string, errors: Array<{ __typename?: 'ErrorDetail', fieldName: string, messages: Array<string> }> }> | null } };

export type AssignPersonStudentsMutationVariables = Exact<{
  personId: Scalars['UUID']['input'];
  studentIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type AssignPersonStudentsMutation = { __typename?: 'Mutation', assignPersonStudents: { __typename: 'AssignPersonStudentsPayload', person?: { __typename?: 'Person', id: any } | null, errors?: Array<{ __typename?: 'EntityLockedError' } | { __typename?: 'EntityNotFoundError' } | { __typename?: 'UnknownError' } | { __typename?: 'ValidationError', message: string, errors: Array<{ __typename?: 'ErrorDetail', fieldName: string, messages: Array<string> }> }> | null } };

export type EditStudentParentEmailMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  parentEmail: Scalars['String']['input'];
}>;


export type EditStudentParentEmailMutation = { __typename?: 'Mutation', editStudentParentEmail: { __typename: 'EditStudentParentEmailPayload', student?: { __typename?: 'Student', id: any } | null, errors?: Array<{ __typename?: 'EntityNotFoundError' } | { __typename?: 'UnknownError' } | { __typename?: 'ValidationError', message: string, errors: Array<{ __typename?: 'ErrorDetail', fieldName: string, messages: Array<string> }> }> | null } };

export type TransferStudentLocationMutationVariables = Exact<{
  studentId: Scalars['UUID']['input'];
  locationId: Scalars['UUID']['input'];
  personIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type TransferStudentLocationMutation = { __typename?: 'Mutation', transferStudentLocation: { __typename?: 'TransferStudentLocationPayload', student?: (
      { __typename?: 'Student' }
      & { ' $fragmentRefs'?: { 'SelectedStudent_StudentFragment': SelectedStudent_StudentFragment } }
    ) | null } };

export type SelectedStudent_StudentFragment = { __typename: 'Student', id: any, locationId: any, firstName?: string | null, middleName?: string | null, lastName?: string | null, dob: any, postalCode?: string | null, parentEmail?: string | null, parentPhone?: string | null, email?: string | null, startDate?: any | null, endDate?: any | null, expired: boolean, references: number, parentalConsentStatus?: string | null, consentEmailSentTimes: number, location: { __typename?: 'Location', name?: string | null }, lastConsentAction?: { __typename?: 'History', id: any, type?: string | null, createdAt: any } | null, persons?: { __typename?: 'PersonsConnection', edges?: Array<{ __typename?: 'PersonsEdge', cursor: string, node: { __typename?: 'Person', id: any } }> | null } | null, studentCustomFields: Array<{ __typename: 'StudentCustomField', value?: string | null, customField?: { __typename: 'CustomField', id: any } | null }> } & { ' $fragmentName'?: 'SelectedStudent_StudentFragment' };

export type UnassignPersonStudentsMutationVariables = Exact<{
  personId: Scalars['UUID']['input'];
  studentIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type UnassignPersonStudentsMutation = { __typename?: 'Mutation', unassignPersonStudents: { __typename: 'UnassignPersonStudentsPayload', person?: { __typename?: 'Person', id: any, students?: { __typename?: 'StudentsConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean }, edges?: Array<{ __typename?: 'StudentsEdge', cursor: string, node: { __typename?: 'Student', id: any, firstName?: string | null, lastName?: string | null, dob: any, createdAt: any, sessions: Array<{ __typename?: 'Session', id: any, createdAt: any, finishedAt?: any | null }>, lastSession?: { __typename?: 'Session', finishedAt?: any | null } | null } }> | null } | null } | null, errors?: Array<{ __typename: 'EntityBusinessRuleError' } | { __typename: 'EntityLockedError' } | { __typename: 'EntityNotFoundError' } | { __typename: 'UnknownError' } | { __typename: 'ValidationError', message: string, errors: Array<{ __typename?: 'ErrorDetail', fieldName: string, messages: Array<string> }> }> | null } };

export type GetCompanyQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetCompanyQuery = { __typename?: 'Query', company?: { __typename?: 'Company', id: any, name?: string | null, type?: string | null, paidUsers: number, activeUsers: number, persons: Array<{ __typename?: 'Person', id: any, firstName: string, lastName: string, status?: string | null, sessions: Array<{ __typename?: 'Session', id: any }>, role?: { __typename?: 'Role', id: any, name: string } | null }>, locations: Array<{ __typename?: 'Location', id: any, name?: string | null, streetLineOne?: string | null, streetLineTwo?: string | null, city?: string | null, country?: string | null, state?: string | null, postalCode?: string | null, totalStudents: number, totalStaff: number, customFields: Array<{ __typename?: 'CustomField', id: any, name?: string | null, type?: string | null, required: boolean, description?: string | null }> }>, companySubscriptions: Array<{ __typename?: 'CompanySubscription', id: any, startDate: any, endDate: any, status?: string | null, subscription?: { __typename?: 'Subscription', name?: string | null, id: any } | null }>, companyConsentPolicy: { __typename?: 'CompanyConsentPolicy', needParentalConsent: boolean, autoParentalConsent: boolean, timeoutWindow?: number | null }, companyInterventionPolicy: { __typename?: 'CompanyInterventionPolicy', abuseAtHome: boolean, safeAtHome: boolean, suicide: boolean }, companyTopFlags: Array<{ __typename?: 'FlagRankingDTO', flagTitle: string, flagId: any, rankings: Array<{ __typename?: 'RankingItemDTO', label: string, total: number, rank: number }> }> } | null };

export type GetCompanyLocationsQueryVariables = Exact<{
  companyId: Scalars['UUID']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCompanyLocationsQuery = { __typename?: 'Query', locationsByCompanyId?: { __typename?: 'LocationsByCompanyIdConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges?: Array<{ __typename?: 'LocationsByCompanyIdEdge', cursor: string, node: { __typename?: 'Location', id: any, name?: string | null, postalCode?: string | null, streetLineOne?: string | null, streetLineTwo?: string | null, city?: string | null, state?: string | null, country?: string | null, status?: string | null, totalStudents: number, totalStaff: number, customFields: Array<{ __typename?: 'CustomField', id: any, name?: string | null, type?: string | null, required: boolean, description?: string | null }> } }> | null } | null };

export type GetCompanySessionCategoriesQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetCompanySessionCategoriesQuery = { __typename?: 'Query', company?: { __typename?: 'Company', companySessionCategories: { __typename?: 'CompanySessionCategoryList', rankings: Array<{ __typename?: 'CategoryTypeRankingDTO', questionId: any, groupKey: string, questionTitle: string, rankings: Array<{ __typename?: 'CategoryRankingDTO', rank: number, categoryType: string, categoryTitle: string, total: number }> }> } } | null };

export type GetCompanyStatsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetCompanyStatsQuery = { __typename?: 'Query', company?: { __typename?: 'Company', id: any, name?: string | null, paidUsers: number, activeUsers: number, companySubscriptions: Array<{ __typename?: 'CompanySubscription', startDate: any, endDate: any }>, sessions: Array<{ __typename?: 'Session', id: any, type: string, category: string, data?: string | null, status?: string | null, checkpoint?: { __typename?: 'SessionCheckpoint', current?: { __typename?: 'SessionCheckpointDetail', name: string } | null } | null }> } | null };

export type GetCompanyStudentsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetCompanyStudentsQuery = { __typename?: 'Query', company?: { __typename?: 'Company', students: Array<{ __typename?: 'Student', id: any, dob: any }>, sessionStats: { __typename: 'CompanySessionStats', crisisSupportIndicated: number, intensiveSupportIndicated: number, supportIndicated: number, preventionAndStrengthIndicated: number, inTherapy: number, hasRecentDeath: number, beenBullied: number }, companyActionHistory: { __typename?: 'CompanyActionHistory', referralsMade: number, educationalMaterialsSent: number }, companyStudentAgeFlags: Array<{ __typename?: 'CompanyStudentAgeFlags', ageAtSession: number, assessmentData?: { __typename?: 'AssessmentData', feRisk: number, feProtective: number, youRisk: number, youProtective: number, ace: number, pce: number, anxiety: number, depression: number, adhd: number, suicidality: number } | null, student?: { __typename?: 'Student', id: any } | null }>, companyTopFlags: Array<{ __typename?: 'FlagRankingDTO', flagTitle: string, flagId: any, rankings: Array<{ __typename?: 'RankingItemDTO', label: string, total: number, rank: number }> }> } | null };

export type GetCompanySubscriptionsQueryVariables = Exact<{
  companyId: Scalars['UUID']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCompanySubscriptionsQuery = { __typename?: 'Query', companySubscriptions?: { __typename?: 'CompanySubscriptionsConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null, startCursor?: string | null }, edges?: Array<{ __typename?: 'CompanySubscriptionsEdge', cursor: string, node: { __typename?: 'CompanySubscription', id: any, startDate: any, endDate: any, status?: string | null, subscription?: { __typename?: 'Subscription', id: any, name?: string | null, description?: string | null } | null } }> | null } | null };

export type LocationCustomFieldsQueryVariables = Exact<{
  locationId: Scalars['UUID']['input'];
}>;


export type LocationCustomFieldsQuery = { __typename?: 'Query', location?: { __typename?: 'Location', customFields: Array<{ __typename?: 'CustomField', id: any, position: number, type?: string | null, name?: string | null, description?: string | null }> } | null };

export type GetLocationQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetLocationQuery = { __typename?: 'Query', location?: { __typename?: 'Location', id: any, name?: string | null, streetLineOne?: string | null, streetLineTwo?: string | null, city?: string | null, state?: string | null, country?: string | null, postalCode?: string | null, totalStudents: number, totalStaff: number, customFields: Array<{ __typename?: 'CustomField', id: any, name?: string | null, type?: string | null, description?: string | null, required: boolean }> } | null };

export type GetLocationCustomFieldsQueryVariables = Exact<{
  locationId: Scalars['UUID']['input'];
}>;


export type GetLocationCustomFieldsQuery = { __typename?: 'Query', customFields: Array<{ __typename: 'CustomField', id: any, name?: string | null, type?: string | null, required: boolean, description?: string | null }> };

export type GetMeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeQuery = { __typename?: 'Query', me?: { __typename?: 'Person', id: any } | null };

export type GetPeopleWithSessionCountQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPeopleWithSessionCountQuery = { __typename?: 'Query', personStatsPerCompany?: { __typename?: 'PersonStatsPerCompanyConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges?: Array<{ __typename?: 'PersonStatsPerCompanyEdge', node: { __typename?: 'Person', id: any, firstName: string, lastName: string, totalCompleteSessions: number, lastRunSession: any, workLists: Array<{ __typename?: 'WorkList', status?: string | null }>, singleStudents: Array<{ __typename?: 'Student', id: any, firstName?: string | null, lastName?: string | null, locationId: any, references: number }>, locations?: { __typename?: 'LocationsConnection', edges?: Array<{ __typename?: 'LocationsEdge', node: { __typename?: 'Location', id: any, name?: string | null } }> | null } | null } }> | null } | null };

export type PeopleForLink__PersonFragment = { __typename?: 'Person', id: any, firstName: string, middleName?: string | null, lastName: string, jobTitle?: string | null, email?: string | null, startDate?: any | null, endDate?: any | null, expired: boolean, role?: { __typename?: 'Role', name: string, normalizedName: string } | null, students?: (
    { __typename?: 'StudentsConnection' }
    & { ' $fragmentRefs'?: { 'PeopleForLink__StudentFragmentFragment': PeopleForLink__StudentFragmentFragment } }
  ) | null } & { ' $fragmentName'?: 'PeopleForLink__PersonFragment' };

export type PeopleForLink__StudentFragmentFragment = { __typename?: 'StudentsConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges?: Array<{ __typename?: 'StudentsEdge', cursor: string, node: { __typename?: 'Student', id: any, firstName?: string | null, lastName?: string | null, dob: any, references: number } }> | null } & { ' $fragmentName'?: 'PeopleForLink__StudentFragmentFragment' };

export type SelectedPerson_PersonFragment = { __typename?: 'Person', id: any, firstName: string, middleName?: string | null, lastName: string, jobTitle?: string | null, email?: string | null, startDate?: any | null, endDate?: any | null, expired: boolean, role?: { __typename?: 'Role', name: string, normalizedName: string, clientFacingName: string } | null, students?: (
    { __typename?: 'StudentsConnection' }
    & { ' $fragmentRefs'?: { 'PeopleForLink__StudentFragmentFragment': PeopleForLink__StudentFragmentFragment } }
  ) | null } & { ' $fragmentName'?: 'SelectedPerson_PersonFragment' };

export type GetPeopleQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPeopleQuery = { __typename?: 'Query', persons: Array<{ __typename?: 'Person', id: any, firstName: string, middleName?: string | null, lastName: string, jobTitle?: string | null, email?: string | null, startDate?: any | null, endDate?: any | null, status?: string | null, createdAt: any, expired: boolean, role?: { __typename?: 'Role', name: string, normalizedName: string } | null, company: { __typename?: 'Company', id: any, name?: string | null }, students?: { __typename?: 'StudentsConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean }, edges?: Array<{ __typename?: 'StudentsEdge', cursor: string, node: { __typename?: 'Student', id: any, firstName?: string | null, lastName?: string | null, dob: any, createdAt: any, sessions: Array<{ __typename?: 'Session', id: any, createdAt: any, finishedAt?: any | null }>, lastSession?: { __typename?: 'Session', finishedAt?: any | null } | null } }> | null } | null }> };

export type PeopleForLinkQueryVariables = Exact<{ [key: string]: never; }>;


export type PeopleForLinkQuery = { __typename?: 'Query', persons: Array<(
    { __typename?: 'Person' }
    & { ' $fragmentRefs'?: { 'PeopleForLink__PersonFragment': PeopleForLink__PersonFragment } }
  )> };

export type PersonForLinkQueryVariables = Exact<{
  personId: Scalars['UUID']['input'];
}>;


export type PersonForLinkQuery = { __typename?: 'Query', person: (
    { __typename?: 'Person' }
    & { ' $fragmentRefs'?: { 'PeopleForLink__PersonFragment': PeopleForLink__PersonFragment } }
  ) };

export type PeoplePageQueryVariables = Exact<{
  locationId?: InputMaybe<Scalars['UUID']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type PeoplePageQuery = { __typename?: 'Query', people?: { __typename?: 'PeopleConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges?: Array<{ __typename?: 'PeopleEdge', cursor: string, node: (
        { __typename?: 'Person' }
        & { ' $fragmentRefs'?: { 'SelectedPerson_PersonFragment': SelectedPerson_PersonFragment } }
      ) }> | null } | null, location?: { __typename?: 'Location', totalStaff: number } | null };

export type PersonStudentsQueryVariables = Exact<{
  personId: Scalars['UUID']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PersonStudentsQuery = { __typename?: 'Query', person: { __typename?: 'Person', id: any, students?: { __typename?: 'StudentsConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage: boolean, hasNextPage: boolean }, edges?: Array<(
        { __typename?: 'StudentsEdge' }
        & { ' $fragmentRefs'?: { '_StudentEdgePreviewFragment': _StudentEdgePreviewFragment } }
      )> | null } | null } };

export type _StudentEdgePreviewFragment = { __typename?: 'StudentsEdge', cursor: string, node: { __typename?: 'Student', id: any, firstName?: string | null, lastName?: string | null, dob: any, references: number, location: { __typename?: 'Location', id: any, name?: string | null } } } & { ' $fragmentName'?: '_StudentEdgePreviewFragment' };

export type GetRolesQueryVariables = Exact<{
  companyType: Scalars['String']['input'];
}>;


export type GetRolesQuery = { __typename?: 'Query', roles: Array<{ __typename?: 'Role', name: string, normalizedName: string, clientFacingName: string, default: boolean }> };

export type GetStudentsForLinkQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  origin: QueryOrigin;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetStudentsForLinkQuery = { __typename?: 'Query', students?: { __typename?: 'StudentsConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges?: Array<{ __typename?: 'StudentsEdge', cursor: string, node: { __typename?: 'Student', id: any, firstName?: string | null, lastName?: string | null, dob: any, expired: boolean, studentCustomFields: Array<{ __typename?: 'StudentCustomField', value?: string | null, customField?: { __typename?: 'CustomField', id: any, type?: string | null, name?: string | null } | null }> } }> | null } | null, location?: { __typename?: 'Location', customFields: Array<{ __typename?: 'CustomField', id: any, position: number, type?: string | null, name?: string | null, description?: string | null }> } | null };

export type StudentQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type StudentQuery = { __typename?: 'Query', student: { __typename?: 'Student', id: any, dob: any, email?: string | null, firstName?: string | null, lastName?: string | null, gradeLevel?: number | null, postalCode?: string | null, middleName?: string | null, studentCustomFields: Array<{ __typename?: 'StudentCustomField', value?: string | null, customField?: { __typename?: 'CustomField', id: any, type?: string | null, name?: string | null } | null }>, sessions: Array<{ __typename?: 'Session', id: any, riskRating: number, status?: string | null, createdAt: any, notes: Array<{ __typename?: 'Note', body?: string | null, id: any, data?: string | null }> }>, persons?: { __typename?: 'PersonsConnection', edges?: Array<{ __typename?: 'PersonsEdge', cursor: string, node: { __typename?: 'Person', firstName: string, lastName: string, id: any, role?: { __typename?: 'Role', name: string, normalizedName: string } | null } }> | null } | null, lastSession?: { __typename?: 'Session', id: any, status?: string | null, checkpoint?: { __typename?: 'SessionCheckpoint', current?: { __typename?: 'SessionCheckpointDetail', name: string } | null } | null, summary?: { __typename?: 'SessionSummary', id: any, livingSituation?: string | null, numberOfSiblings: number, peopleCountedOn: Array<string>, livesMainlyWith?: string | null } | null } | null, avatars: Array<{ __typename?: 'Avatar', id: any, bodyId?: any | null, bodyColor?: string | null, eyeColor?: string | null, hairColor?: string | null, helperId?: any | null, shirtColor?: string | null, pantsColor?: string | null, shoesColor?: string | null }> } };

export type StudentsWithLocationDetailsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  origin: QueryOrigin;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type StudentsWithLocationDetailsQuery = { __typename?: 'Query', students?: { __typename?: 'StudentsConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges?: Array<{ __typename?: 'StudentsEdge', cursor: string, node: { __typename?: 'Student', id: any, dob: any, parentEmail?: string | null, firstName?: string | null, lastName?: string | null, gradeLevel?: number | null, studentCustomFields: Array<{ __typename?: 'StudentCustomField', value?: string | null, customField?: { __typename?: 'CustomField', id: any, type?: string | null, name?: string | null } | null }>, persons?: { __typename?: 'PersonsConnection', edges?: Array<{ __typename?: 'PersonsEdge', cursor: string, node: { __typename?: 'Person', firstName: string, lastName: string, id: any, role?: { __typename?: 'Role', name: string, normalizedName: string } | null } }> | null } | null, lastSession?: { __typename?: 'Session', id: any, status?: string | null, checkpoint?: { __typename?: 'SessionCheckpoint', current?: { __typename?: 'SessionCheckpointDetail', name: string } | null } | null, summary?: { __typename?: 'SessionSummary', id: any, livingSituation?: string | null, numberOfSiblings: number, peopleCountedOn: Array<string>, livesMainlyWith?: string | null } | null } | null, avatars: Array<{ __typename?: 'Avatar', id: any, bodyId?: any | null, bodyColor?: string | null, eyeColor?: string | null, hairColor?: string | null, helperId?: any | null, shirtColor?: string | null, pantsColor?: string | null, shoesColor?: string | null }> } }> | null } | null, location?: { __typename?: 'Location', customFields: Array<{ __typename?: 'CustomField', id: any, position: number, type?: string | null, name?: string | null, description?: string | null }> } | null };

export type GetPersonQueryVariables = Exact<{
  origin: QueryOrigin;
}>;


export type GetPersonQuery = { __typename?: 'Query', students?: { __typename?: 'StudentsConnection', edges?: Array<{ __typename?: 'StudentsEdge', node: { __typename?: 'Student', id: any, firstName?: string | null, lastName?: string | null, dob: any } }> | null } | null };

export type WorkListsByPersonQueryVariables = Exact<{ [key: string]: never; }>;


export type WorkListsByPersonQuery = { __typename?: 'Query', me?: { __typename?: 'Person', id: any, firstName: string, lastName: string, workLists: Array<{ __typename?: 'WorkList', id: any, type: string, status?: string | null, createdAt: any, notes: Array<{ __typename?: 'Note', data?: string | null, id: any, createdAt: any, body?: string | null, type?: string | null }>, person?: { __typename?: 'Person', id: any, firstName: string, lastName: string } | null, session?: { __typename?: 'Session', id: any, data?: string | null, createdAt: any, student: { __typename?: 'Student', id: any, firstName?: string | null, lastName?: string | null, createdAt: any }, report: Array<{ __typename?: 'File', id: any }> } | null }> } | null };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me?: { __typename: 'Person', id: any, firstName: string, lastName: string, company: { __typename: 'Company', id: any, type?: string | null, name?: string | null, paidUsers: number, activeUsers: number, companySubscriptions: Array<{ __typename?: 'CompanySubscription', id: any, subscription?: { __typename?: 'Subscription', id: any, name?: string | null } | null }>, companyConsentPolicy: { __typename?: 'CompanyConsentPolicy', needParentalConsent: boolean, autoParentalConsent: boolean } }, dashboardStats: { __typename?: 'DashboardStats', currentLocationStudents: number, totalStudents: number, sessionsCompleteThisWeek: number, changeFromLastWeek: number, pendingConsent: number }, locations?: { __typename?: 'LocationsConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges?: Array<{ __typename?: 'LocationsEdge', node: { __typename?: 'Location', id: any, name?: string | null, streetLineOne?: string | null, streetLineTwo?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, customFields: Array<{ __typename: 'CustomField', id: any, type?: string | null, name?: string | null, position: number }> } }> | null } | null, workLists: Array<{ __typename?: 'WorkList', id: any }>, defaultLocation?: { __typename: 'Location', id: any, name?: string | null, streetLineOne?: string | null, streetLineTwo?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, demoStudent?: { __typename?: 'Student', id: any } | null, customFields: Array<{ __typename: 'CustomField', id: any, type?: string | null, name?: string | null, position: number }> } | null } | null };

export type PendingStudentsQueryVariables = Exact<{
  origin: QueryOrigin;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PendingStudentsQuery = { __typename?: 'Query', students?: { __typename?: 'StudentsConnection', edges?: Array<{ __typename?: 'StudentsEdge', node: { __typename?: 'Student', id: any, firstName?: string | null, lastName?: string | null, parentalConsentStatus?: string | null, location: { __typename?: 'Location', name?: string | null } } }> | null } | null };

export type GetKeywordAnswersForSessionQueryVariables = Exact<{
  sessionId: Scalars['UUID']['input'];
}>;


export type GetKeywordAnswersForSessionQuery = { __typename?: 'Query', keywordAnswersForSession: Array<{ __typename?: 'Answer', id: any, createdAt: any, data?: string | null, question?: { __typename?: 'Question', position: number, title?: string | null } | null, answerCategories: Array<{ __typename?: 'AnswerCategory', id: any, keywordId?: any | null, keyword?: { __typename?: 'Keyword', id: any, wordOrPhrase?: string | null } | null }> }> };

export type StudentSessionsQueryVariables = Exact<{
  studentId: Scalars['UUID']['input'];
}>;


export type StudentSessionsQuery = { __typename?: 'Query', student: { __typename: 'Student', id: any, firstName?: string | null, lastName?: string | null, parentEmail?: string | null, email?: string | null, dob: any, expired: boolean, parentalConsentStatus?: string | null, consentEmailSentTimes: number, lastConsentAction?: { __typename?: 'History', id: any, type?: string | null, createdAt: any } | null, sessions: Array<{ __typename: 'Session', id: any, category: string, data?: string | null, riskRating: number, status?: string | null, type: string, hasKeyWords: boolean, createdAt: any, checkpoint?: { __typename?: 'SessionCheckpoint', values: Array<string>, current?: { __typename?: 'SessionCheckpointDetail', position: number, name: string } | null } | null, launchPerson: { __typename?: 'Person', firstName: string, lastName: string }, worklist?: { __typename?: 'WorkList', id: any, status?: string | null } | null, report: Array<{ __typename?: 'File', id: any, category?: string | null, createdAt: any }>, notes: Array<{ __typename?: 'Note', id: any, type?: string | null, body?: string | null, createdAt: any, person: { __typename?: 'Person', id: any, firstName: string, lastName: string, role?: { __typename?: 'Role', normalizedName: string } | null } }>, history: Array<{ __typename?: 'History', data: any, createdAt: any }> }> } };

export type UnreadWorkListQueryVariables = Exact<{ [key: string]: never; }>;


export type UnreadWorkListQuery = { __typename?: 'Query', me?: { __typename?: 'Person', workLists: Array<{ __typename?: 'WorkList', id: any, createdAt: any, session?: { __typename?: 'Session', id: any, createdAt: any, data?: string | null, student: { __typename?: 'Student', id: any, firstName?: string | null, lastName?: string | null } } | null }> } | null };

export type GetPersonWithLocationsForLinkQueryVariables = Exact<{
  personId: Scalars['UUID']['input'];
}>;


export type GetPersonWithLocationsForLinkQuery = { __typename?: 'Query', person: { __typename?: 'Person', id: any, firstName: string, lastName: string, singleStudents: Array<{ __typename?: 'Student', id: any, locationId: any }>, locations?: { __typename?: 'LocationsConnection', edges?: Array<{ __typename?: 'LocationsEdge', node: { __typename?: 'Location', id: any } }> | null } | null, company: { __typename?: 'Company', locations: Array<{ __typename?: 'Location', id: any, name?: string | null }> } } };

export type PersonStudentsWithLocationQueryVariables = Exact<{
  personId: Scalars['UUID']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type PersonStudentsWithLocationQuery = { __typename?: 'Query', person: { __typename?: 'Person', locationStudents?: { __typename?: 'LocationStudentsConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges?: Array<{ __typename?: 'LocationStudentsEdge', cursor: string, node: { __typename?: 'Student', id: any, firstName?: string | null, lastName?: string | null, dob: any, references: number, location: { __typename?: 'Location', id: any, name?: string | null }, persons?: { __typename?: 'PersonsConnection', edges?: Array<{ __typename?: 'PersonsEdge', cursor: string, node: { __typename?: 'Person', id: any } }> | null } | null } }> | null } | null } };

export type GetPersonLocationsQueryVariables = Exact<{
  personId: Scalars['UUID']['input'];
}>;


export type GetPersonLocationsQuery = { __typename?: 'Query', person: { __typename?: 'Person', locations?: { __typename?: 'LocationsConnection', edges?: Array<{ __typename?: 'LocationsEdge', node: { __typename?: 'Location', id: any, name?: string | null } }> | null } | null, singleStudents: Array<{ __typename?: 'Student', id: any, locationId: any, references: number }> } };

export type PersonStudentAssignMutationVariables = Exact<{
  personId: Scalars['UUID']['input'];
  studentIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type PersonStudentAssignMutation = { __typename: 'Mutation', assignPersonStudents: { __typename?: 'AssignPersonStudentsPayload', person?: { __typename?: 'Person', id: any } | null, errors?: Array<{ __typename?: 'EntityLockedError' } | { __typename?: 'EntityNotFoundError' } | { __typename?: 'UnknownError' } | { __typename?: 'ValidationError', message: string, errors: Array<{ __typename?: 'ErrorDetail', fieldName: string, messages: Array<string> }> }> | null } };

export type PersonStudentUnassignMutationVariables = Exact<{
  personId: Scalars['UUID']['input'];
  studentIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type PersonStudentUnassignMutation = { __typename?: 'Mutation', unassignPersonStudents: { __typename: 'UnassignPersonStudentsPayload', person?: { __typename?: 'Person', id: any } | null, errors?: Array<{ __typename?: 'EntityBusinessRuleError' } | { __typename?: 'EntityLockedError' } | { __typename?: 'EntityNotFoundError' } | { __typename?: 'UnknownError' } | { __typename?: 'ValidationError', message: string, errors: Array<{ __typename?: 'ErrorDetail', fieldName: string, messages: Array<string> }> }> | null } };

export type StudentPersonsLinkQueryVariables = Exact<{
  locationId?: InputMaybe<Scalars['UUID']['input']>;
  studentId?: InputMaybe<Scalars['UUID']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
}>;


export type StudentPersonsLinkQuery = { __typename?: 'Query', location?: { __typename?: 'Location', persons?: { __typename?: 'PersonsConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges?: Array<{ __typename?: 'PersonsEdge', cursor: string, node: (
          { __typename?: 'Person' }
          & { ' $fragmentRefs'?: { '_PersonFragment': _PersonFragment } }
        ) }> | null } | null } | null };

export type _PersonFragment = { __typename?: 'Person', id: any, firstName: string, middleName?: string | null, lastName: string, jobTitle?: string | null, email?: string | null, startDate?: any | null, endDate?: any | null, expired: boolean, role?: { __typename?: 'Role', name: string, normalizedName: string, clientFacingName: string } | null, students?: { __typename?: 'StudentsConnection', totalCount: number, edges?: Array<{ __typename?: 'StudentsEdge', node: { __typename?: 'Student', id: any, references: number } }> | null } | null } & { ' $fragmentName'?: '_PersonFragment' };

export type StudentQueryQueryVariables = Exact<{
  studentId: Scalars['UUID']['input'];
}>;


export type StudentQueryQuery = { __typename?: 'Query', student: { __typename: 'Student', id: any, locationId: any, firstName?: string | null, middleName?: string | null, lastName?: string | null, dob: any, postalCode?: string | null, parentEmail?: string | null, parentPhone?: string | null, startDate?: any | null, endDate?: any | null, expired: boolean, references: number, studentCustomFields: Array<{ __typename?: 'StudentCustomField', value?: string | null, customField?: { __typename?: 'CustomField', id: any } | null }> }, locations: Array<{ __typename: 'Location', id: any, customFields: Array<{ __typename: 'CustomField', id: any, type?: string | null, name?: string | null, position: number }> }> };

export type EditStudentMutationVariables = Exact<{
  input: EditStudentInput;
}>;


export type EditStudentMutation = { __typename?: 'Mutation', editStudent: { __typename: 'EditStudentPayload', student?: { __typename?: 'Student', id: any } | null, errors?: Array<{ __typename: 'EntityNotFoundError', message: string } | { __typename: 'UnknownError', message: string } | { __typename: 'ValidationError', errors: Array<{ __typename?: 'ErrorDetail', fieldName: string, messages: Array<string> }> }> | null } };

export type StudentNotesQueryVariables = Exact<{
  studentId: Scalars['UUID']['input'];
}>;


export type StudentNotesQuery = { __typename?: 'Query', student: { __typename: 'Student', id: any, firstName?: string | null, lastName?: string | null, allNotes: Array<{ __typename?: 'Note', id: any, body?: string | null, type?: string | null, origin?: string | null, createdAt: any, sessionNotes: Array<{ __typename?: 'SessionNote', session?: { __typename?: 'Session', id: any, createdAt: any } | null }>, person: { __typename?: 'Person', id: any, firstName: string, lastName: string, role?: { __typename?: 'Role', normalizedName: string } | null } }> } };

export type StudentPersonsLinkPreviewQueryVariables = Exact<{
  studentId: Scalars['UUID']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type StudentPersonsLinkPreviewQuery = { __typename?: 'Query', student: { __typename: 'Student', id: any, references: number, persons?: { __typename?: 'PersonsConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean }, edges?: Array<{ __typename?: 'PersonsEdge', cursor: string, node: (
          { __typename?: 'Person' }
          & { ' $fragmentRefs'?: { '_StudentPersonFragment': _StudentPersonFragment } }
        ) }> | null } | null } };

export type _StudentPersonFragment = { __typename: 'Person', id: any, firstName: string, lastName: string, role?: { __typename?: 'Role', name: string, normalizedName: string, clientFacingName: string } | null } & { ' $fragmentName'?: '_StudentPersonFragment' };

export type ExpireStudentMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type ExpireStudentMutation = { __typename?: 'Mutation', expireStudent: { __typename: 'ExpireStudentPayload', student?: { __typename?: 'Student', id: any, expired: boolean } | null, errors?: Array<{ __typename: 'EntityLockedError', id: any, entity: string, message: string, updatedAt?: any | null } | { __typename: 'EntityNotFoundError', id: any, message: string } | { __typename: 'UnknownError', message: string } | { __typename: 'ValidationError', errors: Array<{ __typename?: 'ErrorDetail', fieldName: string, messages: Array<string> }> }> | null } };

export type SelectedStudentQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SelectedStudentQuery = { __typename?: 'Query', student: (
    { __typename?: 'Student' }
    & { ' $fragmentRefs'?: { 'SelectedStudent_StudentFragment': SelectedStudent_StudentFragment } }
  ) };

export type StudentPersonsAssignMutationVariables = Exact<{
  studentId: Scalars['UUID']['input'];
  personIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type StudentPersonsAssignMutation = { __typename?: 'Mutation', assignStudentPersons: { __typename?: 'AssignStudentPersonsPayload', student?: { __typename: 'Student', id: any, references: number } | null, errors?: Array<{ __typename: 'EntityLockedError' } | { __typename: 'EntityNotFoundError' } | { __typename: 'UnknownError' } | { __typename: 'ValidationError', message: string, errors: Array<{ __typename?: 'ErrorDetail', fieldName: string, messages: Array<string> }> }> | null } };

export type StudentPersonsUnassignMutationVariables = Exact<{
  studentId: Scalars['UUID']['input'];
  personIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type StudentPersonsUnassignMutation = { __typename?: 'Mutation', unassignStudentPersons: { __typename?: 'UnassignStudentPersonsPayload', student?: { __typename: 'Student', id: any, references: number } | null, errors?: Array<{ __typename: 'EntityBusinessRuleError' } | { __typename: 'EntityLockedError' } | { __typename: 'EntityNotFoundError' } | { __typename: 'UnknownError' } | { __typename: 'ValidationError', message: string, errors: Array<{ __typename?: 'ErrorDetail', fieldName: string, messages: Array<string> }> }> | null } };

export const SelectedStudent_StudentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SelectedStudent_Student"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Student"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locationId"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"middleName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"dob"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"parentEmail"}},{"kind":"Field","name":{"kind":"Name","value":"parentPhone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"expired"}},{"kind":"Field","name":{"kind":"Name","value":"references"}},{"kind":"Field","name":{"kind":"Name","value":"parentalConsentStatus"}},{"kind":"Field","name":{"kind":"Name","value":"lastConsentAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"consentEmailSentTimes"}},{"kind":"Field","name":{"kind":"Name","value":"persons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"studentCustomFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"customField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<SelectedStudent_StudentFragment, unknown>;
export const PeopleForLink__StudentFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PeopleForLink__StudentFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StudentsConnection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"dob"}},{"kind":"Field","name":{"kind":"Name","value":"references"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]} as unknown as DocumentNode<PeopleForLink__StudentFragmentFragment, unknown>;
export const PeopleForLink__PersonFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PeopleForLink__Person"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"middleName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"expired"}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"normalizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"students"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PeopleForLink__StudentFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PeopleForLink__StudentFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StudentsConnection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"dob"}},{"kind":"Field","name":{"kind":"Name","value":"references"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]} as unknown as DocumentNode<PeopleForLink__PersonFragment, unknown>;
export const SelectedPerson_PersonFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SelectedPerson_Person"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"middleName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"expired"}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"normalizedName"}},{"kind":"Field","name":{"kind":"Name","value":"clientFacingName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"students"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PeopleForLink__StudentFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PeopleForLink__StudentFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StudentsConnection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"dob"}},{"kind":"Field","name":{"kind":"Name","value":"references"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]} as unknown as DocumentNode<SelectedPerson_PersonFragment, unknown>;
export const _StudentEdgePreviewFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"_studentEdgePreview"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StudentsEdge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"dob"}},{"kind":"Field","name":{"kind":"Name","value":"references"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<_StudentEdgePreviewFragment, unknown>;
export const _PersonFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"_person"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"middleName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"expired"}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"normalizedName"}},{"kind":"Field","name":{"kind":"Name","value":"clientFacingName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"students"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"studentId"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"ACTIVE"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"references"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<_PersonFragment, unknown>;
export const _StudentPersonFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"_studentPerson"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"normalizedName"}},{"kind":"Field","name":{"kind":"Name","value":"clientFacingName"}}]}}]}}]} as unknown as DocumentNode<_StudentPersonFragment, unknown>;
export const SelectedPersonDocument = {"__meta__":{"hash":"dd95744052354e26a4f6ecf9335dab681207c1c3"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SelectedPerson"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"person"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SelectedPerson_Person"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PeopleForLink__StudentFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StudentsConnection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"dob"}},{"kind":"Field","name":{"kind":"Name","value":"references"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SelectedPerson_Person"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"middleName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"expired"}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"normalizedName"}},{"kind":"Field","name":{"kind":"Name","value":"clientFacingName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"students"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PeopleForLink__StudentFragment"}}]}}]}}]} as unknown as DocumentNode<SelectedPersonQuery, SelectedPersonQueryVariables>;
export const AddAnswerDocument = {"__meta__":{"hash":"e43b52bf33e6241dd68891cdaea44e44f689d3bf"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddAnswer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sessionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"questionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addAnswer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sessionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sessionId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"questionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"questionId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<AddAnswerMutation, AddAnswerMutationVariables>;
export const AddCustomFieldDocument = {"__meta__":{"hash":"be9ce9ee97af4aa3f2b5b98fe8ab3f547b99132a"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddCustomField"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddCustomFieldInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addCustomField"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<AddCustomFieldMutation, AddCustomFieldMutationVariables>;
export const MarkReviewedDocument = {"__meta__":{"hash":"5e1853963b5949c156a9159b4841f0fb44afb623"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"markReviewed"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markWorkListAsRead"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"workList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<MarkReviewedMutation, MarkReviewedMutationVariables>;
export const AddPersonDocument = {"__meta__":{"hash":"1499a41230424d877278d0d3d8bd7e7ae4b79544"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddPerson"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"middleName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobTitle"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"role"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PersonRole"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addPerson"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"firstName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"middleName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"middleName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lastName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"jobTitle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobTitle"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"userRole"},"value":{"kind":"Variable","name":{"kind":"Name","value":"role"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ValidationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldName"}},{"kind":"Field","name":{"kind":"Name","value":"messages"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EntityNotFoundError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UnknownError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AddPersonMutation, AddPersonMutationVariables>;
export const AssignLocationPersonMutationDocument = {"__meta__":{"hash":"b85d789dad73e7c1e2e8d3747a3bec74a0f4389a"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AssignLocationPersonMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"personIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignLocationPersons"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"locationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"personIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"personIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"totalStaff"}}]}}]}}]}}]} as unknown as DocumentNode<AssignLocationPersonMutationMutation, AssignLocationPersonMutationMutationVariables>;
export const AssignPersonLocationsMutationDocument = {"__meta__":{"hash":"685c71b5b1389c0864b79841b2d767a7d814f9b3"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AssignPersonLocationsMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"personId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignPersonLocations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"personId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"personId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"locationIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<AssignPersonLocationsMutationMutation, AssignPersonLocationsMutationMutationVariables>;
export const AssignStudentPersonsDocument = {"__meta__":{"hash":"ca4c9c24c08d0bffbd1b8189597c08bd8f3a333a"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AssignStudentPersons"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"studentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"personIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignStudentPersons"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"studentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"studentId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"personIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"personIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"student"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<AssignStudentPersonsMutation, AssignStudentPersonsMutationVariables>;
export const EditPersonDocument = {"__meta__":{"hash":"a889d427e40bb73edade60cac03d3a7ace135872"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EditPerson"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EditPersonInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editPerson"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"middleName"}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"normalizedName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ValidationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldName"}},{"kind":"Field","name":{"kind":"Name","value":"messages"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<EditPersonMutation, EditPersonMutationVariables>;
export const ExpirePersonDocument = {"__meta__":{"hash":"0d44d5b24376536a9079a4c6b257725de2a5a834"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ExpirePerson"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"personId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"expirePerson"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"personId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"expired"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ValidationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldName"}},{"kind":"Field","name":{"kind":"Name","value":"messages"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EntityLockedError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"entity"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UnknownError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ExpirePersonMutation, ExpirePersonMutationVariables>;
export const UnassignLocationPersonMutationDocument = {"__meta__":{"hash":"f2464f407498742aec45b0c86881180bbc2bd6a3"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UnassignLocationPersonMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"personIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unassignLocationPersons"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"locationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"personIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"personIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<UnassignLocationPersonMutationMutation, UnassignLocationPersonMutationMutationVariables>;
export const UnassignPersonLocationsMutationDocument = {"__meta__":{"hash":"e1cd12e41faf301a893b92b48d3f10e4b4846eec"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UnassignPersonLocationsMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"personId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unassignPersonLocations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"personId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"personId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"locationIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<UnassignPersonLocationsMutationMutation, UnassignPersonLocationsMutationMutationVariables>;
export const UnassignStudentPersonsDocument = {"__meta__":{"hash":"7c030aea9c5f117cc3f01c9e5239412ca2b7376f"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UnassignStudentPersons"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"studentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"personIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unassignStudentPersons"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"studentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"studentId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"personIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"personIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"student"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dob"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"gradeLevel"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"middleName"}},{"kind":"Field","name":{"kind":"Name","value":"studentCustomFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sessions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"notes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}},{"kind":"Field","name":{"kind":"Name","value":"riskRating"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"persons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"normalizedName"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastSession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"checkpoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"current"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"summary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"livingSituation"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfSiblings"}},{"kind":"Field","name":{"kind":"Name","value":"peopleCountedOn"}},{"kind":"Field","name":{"kind":"Name","value":"livesMainlyWith"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"avatars"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bodyId"}},{"kind":"Field","name":{"kind":"Name","value":"bodyColor"}},{"kind":"Field","name":{"kind":"Name","value":"eyeColor"}},{"kind":"Field","name":{"kind":"Name","value":"hairColor"}},{"kind":"Field","name":{"kind":"Name","value":"helperId"}},{"kind":"Field","name":{"kind":"Name","value":"shirtColor"}},{"kind":"Field","name":{"kind":"Name","value":"pantsColor"}},{"kind":"Field","name":{"kind":"Name","value":"shoesColor"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UnassignStudentPersonsMutation, UnassignStudentPersonsMutationVariables>;
export const AddStudentDocument = {"__meta__":{"hash":"12e2b6259420876ce248394ff6cf3a3187fe2be2"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddStudent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddStudentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addStudent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"student"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ValidationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldName"}},{"kind":"Field","name":{"kind":"Name","value":"messages"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AddStudentMutation, AddStudentMutationVariables>;
export const AssignPersonStudentsDocument = {"__meta__":{"hash":"ff5896a35b9e602ef2891f9c86c54cbb50fd1336"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AssignPersonStudents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"personId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"studentIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignPersonStudents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"personId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"personId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"studentIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"studentIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ValidationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldName"}},{"kind":"Field","name":{"kind":"Name","value":"messages"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AssignPersonStudentsMutation, AssignPersonStudentsMutationVariables>;
export const EditStudentParentEmailDocument = {"__meta__":{"hash":"7a78e0414cf968350fb96c69ec5a1d1eb1d16562"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EditStudentParentEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parentEmail"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editStudentParentEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"parentEmail"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentEmail"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"student"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ValidationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldName"}},{"kind":"Field","name":{"kind":"Name","value":"messages"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<EditStudentParentEmailMutation, EditStudentParentEmailMutationVariables>;
export const TransferStudentLocationDocument = {"__meta__":{"hash":"5a068c5961c64a4f77d5c4262998b31325fcfcaf"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TransferStudentLocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"studentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"personIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transferStudentLocation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"studentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"studentId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"locationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"personIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"personIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"student"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SelectedStudent_Student"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SelectedStudent_Student"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Student"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locationId"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"middleName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"dob"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"parentEmail"}},{"kind":"Field","name":{"kind":"Name","value":"parentPhone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"expired"}},{"kind":"Field","name":{"kind":"Name","value":"references"}},{"kind":"Field","name":{"kind":"Name","value":"parentalConsentStatus"}},{"kind":"Field","name":{"kind":"Name","value":"lastConsentAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"consentEmailSentTimes"}},{"kind":"Field","name":{"kind":"Name","value":"persons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"studentCustomFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"customField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<TransferStudentLocationMutation, TransferStudentLocationMutationVariables>;
export const UnassignPersonStudentsDocument = {"__meta__":{"hash":"46555c40f4334e779081562baa310b51baf498b7"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UnassignPersonStudents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"personId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"studentIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unassignPersonStudents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"personId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"personId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"studentIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"studentIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"students"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"dob"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"sessions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"finishedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastSession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"finishedAt"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ValidationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldName"}},{"kind":"Field","name":{"kind":"Name","value":"messages"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UnassignPersonStudentsMutation, UnassignPersonStudentsMutationVariables>;
export const GetCompanyDocument = {"__meta__":{"hash":"0d00e19a4af14026cec781558a9693565d46b5a9"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCompany"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"company"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"paidUsers"}},{"kind":"Field","name":{"kind":"Name","value":"activeUsers"}},{"kind":"Field","name":{"kind":"Name","value":"persons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"sessions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"locations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"streetLineOne"}},{"kind":"Field","name":{"kind":"Name","value":"streetLineTwo"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"customFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalStudents"}},{"kind":"Field","name":{"kind":"Name","value":"totalStaff"}}]}},{"kind":"Field","name":{"kind":"Name","value":"companySubscriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"subscription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"companyConsentPolicy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"needParentalConsent"}},{"kind":"Field","name":{"kind":"Name","value":"autoParentalConsent"}},{"kind":"Field","name":{"kind":"Name","value":"timeoutWindow"}}]}},{"kind":"Field","name":{"kind":"Name","value":"companyInterventionPolicy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"abuseAtHome"}},{"kind":"Field","name":{"kind":"Name","value":"safeAtHome"}},{"kind":"Field","name":{"kind":"Name","value":"suicide"}}]}},{"kind":"Field","name":{"kind":"Name","value":"companyTopFlags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flagTitle"}},{"kind":"Field","name":{"kind":"Name","value":"flagId"}},{"kind":"Field","name":{"kind":"Name","value":"rankings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCompanyQuery, GetCompanyQueryVariables>;
export const GetCompanyLocationsDocument = {"__meta__":{"hash":"a6be205b6f7efe6290d1ca66263baa1c9afe3644"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCompanyLocations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationsByCompanyId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"streetLineOne"}},{"kind":"Field","name":{"kind":"Name","value":"streetLineTwo"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"customFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalStudents"}},{"kind":"Field","name":{"kind":"Name","value":"totalStaff"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCompanyLocationsQuery, GetCompanyLocationsQueryVariables>;
export const GetCompanySessionCategoriesDocument = {"__meta__":{"hash":"d34a76261e9714563a8bafd7946e2c66b4ae5b37"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCompanySessionCategories"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"company"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companySessionCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rankings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"questionId"}},{"kind":"Field","name":{"kind":"Name","value":"groupKey"}},{"kind":"Field","name":{"kind":"Name","value":"questionTitle"}},{"kind":"Field","name":{"kind":"Name","value":"rankings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"categoryType"}},{"kind":"Field","name":{"kind":"Name","value":"categoryTitle"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCompanySessionCategoriesQuery, GetCompanySessionCategoriesQueryVariables>;
export const GetCompanyStatsDocument = {"__meta__":{"hash":"84b37ee90a3650faf843926c1ea82ec838d863d6"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCompanyStats"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"company"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"paidUsers"}},{"kind":"Field","name":{"kind":"Name","value":"activeUsers"}},{"kind":"Field","name":{"kind":"Name","value":"companySubscriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sessions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"checkpoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"current"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCompanyStatsQuery, GetCompanyStatsQueryVariables>;
export const GetCompanyStudentsDocument = {"__meta__":{"hash":"42988d8fcd87bfce9e9f2f299705068e92de3e97"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCompanyStudents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"company"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"students"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dob"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sessionStats"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"crisisSupportIndicated"}},{"kind":"Field","name":{"kind":"Name","value":"intensiveSupportIndicated"}},{"kind":"Field","name":{"kind":"Name","value":"supportIndicated"}},{"kind":"Field","name":{"kind":"Name","value":"preventionAndStrengthIndicated"}},{"kind":"Field","name":{"kind":"Name","value":"inTherapy"}},{"kind":"Field","name":{"kind":"Name","value":"hasRecentDeath"}},{"kind":"Field","name":{"kind":"Name","value":"beenBullied"}}]}},{"kind":"Field","name":{"kind":"Name","value":"companyActionHistory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"referralsMade"}},{"kind":"Field","name":{"kind":"Name","value":"educationalMaterialsSent"}}]}},{"kind":"Field","name":{"kind":"Name","value":"companyStudentAgeFlags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ageAtSession"}},{"kind":"Field","name":{"kind":"Name","value":"assessmentData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feRisk"}},{"kind":"Field","name":{"kind":"Name","value":"feProtective"}},{"kind":"Field","name":{"kind":"Name","value":"youRisk"}},{"kind":"Field","name":{"kind":"Name","value":"youProtective"}},{"kind":"Field","name":{"kind":"Name","value":"ace"}},{"kind":"Field","name":{"kind":"Name","value":"pce"}},{"kind":"Field","name":{"kind":"Name","value":"anxiety"}},{"kind":"Field","name":{"kind":"Name","value":"depression"}},{"kind":"Field","name":{"kind":"Name","value":"adhd"}},{"kind":"Field","name":{"kind":"Name","value":"suicidality"}}]}},{"kind":"Field","name":{"kind":"Name","value":"student"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"companyTopFlags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flagTitle"}},{"kind":"Field","name":{"kind":"Name","value":"flagId"}},{"kind":"Field","name":{"kind":"Name","value":"rankings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCompanyStudentsQuery, GetCompanyStudentsQueryVariables>;
export const GetCompanySubscriptionsDocument = {"__meta__":{"hash":"815e94420b265e776d4b6346aef693eef3cf3df3"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCompanySubscriptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companySubscriptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"subscription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCompanySubscriptionsQuery, GetCompanySubscriptionsQueryVariables>;
export const LocationCustomFieldsDocument = {"__meta__":{"hash":"abe5d5d6c5ce754411c9b6db58174a67ca6da1dd"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LocationCustomFields"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]} as unknown as DocumentNode<LocationCustomFieldsQuery, LocationCustomFieldsQueryVariables>;
export const GetLocationDocument = {"__meta__":{"hash":"a87baf6748a6f026259a275ab4f87c2831ac7c55"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"streetLineOne"}},{"kind":"Field","name":{"kind":"Name","value":"streetLineTwo"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"customFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"required"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalStudents"}},{"kind":"Field","name":{"kind":"Name","value":"totalStaff"}}]}}]}}]} as unknown as DocumentNode<GetLocationQuery, GetLocationQueryVariables>;
export const GetLocationCustomFieldsDocument = {"__meta__":{"hash":"38690e8cac0598b3af1bb10538dc1b080c9bfe7c"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLocationCustomFields"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<GetLocationCustomFieldsQuery, GetLocationCustomFieldsQueryVariables>;
export const GetMeDocument = {"__meta__":{"hash":"f9c9eb66e9bd5f1b9f678b1bcf762a1746ef9a5c"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getMe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetMeQuery, GetMeQueryVariables>;
export const GetPeopleWithSessionCountDocument = {"__meta__":{"hash":"e43b777c5a38696e62f18e52475e84f60caa1442"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPeopleWithSessionCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"personStatsPerCompany"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"workLists"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"singleStudents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"locationId"}},{"kind":"Field","name":{"kind":"Name","value":"references"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCompleteSessions"}},{"kind":"Field","name":{"kind":"Name","value":"lastRunSession"}},{"kind":"Field","name":{"kind":"Name","value":"locations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetPeopleWithSessionCountQuery, GetPeopleWithSessionCountQueryVariables>;
export const GetPeopleDocument = {"__meta__":{"hash":"80928dfce9c8dc53bc71f64e06c0ea7684135a08"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPeople"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"persons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"middleName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"expired"}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"normalizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"students"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"dob"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"sessions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"finishedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastSession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"finishedAt"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]} as unknown as DocumentNode<GetPeopleQuery, GetPeopleQueryVariables>;
export const PeopleForLinkDocument = {"__meta__":{"hash":"27349afa4043ca0fce7202680b667f68102b780d"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PeopleForLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"persons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PeopleForLink__Person"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PeopleForLink__StudentFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StudentsConnection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"dob"}},{"kind":"Field","name":{"kind":"Name","value":"references"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PeopleForLink__Person"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"middleName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"expired"}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"normalizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"students"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PeopleForLink__StudentFragment"}}]}}]}}]} as unknown as DocumentNode<PeopleForLinkQuery, PeopleForLinkQueryVariables>;
export const PersonForLinkDocument = {"__meta__":{"hash":"fd0a1c6a4645aef9a0d4a74f00fb148809585404"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PersonForLink"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"personId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"person"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"personId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PeopleForLink__Person"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PeopleForLink__StudentFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StudentsConnection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"dob"}},{"kind":"Field","name":{"kind":"Name","value":"references"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PeopleForLink__Person"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"middleName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"expired"}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"normalizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"students"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PeopleForLink__StudentFragment"}}]}}]}}]} as unknown as DocumentNode<PersonForLinkQuery, PersonForLinkQueryVariables>;
export const PeoplePageDocument = {"__meta__":{"hash":"51d4877290cd126c3aa861244c47590413aa1d83"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PeoplePage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"people"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SelectedPerson_Person"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalStaff"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PeopleForLink__StudentFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StudentsConnection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"dob"}},{"kind":"Field","name":{"kind":"Name","value":"references"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SelectedPerson_Person"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"middleName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"expired"}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"normalizedName"}},{"kind":"Field","name":{"kind":"Name","value":"clientFacingName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"students"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PeopleForLink__StudentFragment"}}]}}]}}]} as unknown as DocumentNode<PeoplePageQuery, PeoplePageQueryVariables>;
export const PersonStudentsDocument = {"__meta__":{"hash":"7af5d0f8bab09e97e8ca8f2913f58e631351006f"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PersonStudents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"personId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"person"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"personId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"students"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"ACTIVE"}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"_studentEdgePreview"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"_studentEdgePreview"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StudentsEdge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"dob"}},{"kind":"Field","name":{"kind":"Name","value":"references"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<PersonStudentsQuery, PersonStudentsQueryVariables>;
export const GetRolesDocument = {"__meta__":{"hash":"71a9c54522843c2dc5e79daf6b885508b1ce6079"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRoles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"companyType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"normalizedName"}},{"kind":"Field","name":{"kind":"Name","value":"clientFacingName"}},{"kind":"Field","name":{"kind":"Name","value":"default"}}]}}]}}]} as unknown as DocumentNode<GetRolesQuery, GetRolesQueryVariables>;
export const GetStudentsForLinkDocument = {"__meta__":{"hash":"d94d134724b1dc28681ff4bdbeef7fc3f274332c"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetStudentsForLink"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"NullValue"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"NullValue"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"origin"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QueryOrigin"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"students"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"origin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"origin"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"dob"}},{"kind":"Field","name":{"kind":"Name","value":"expired"}},{"kind":"Field","name":{"kind":"Name","value":"studentCustomFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"customField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]} as unknown as DocumentNode<GetStudentsForLinkQuery, GetStudentsForLinkQueryVariables>;
export const StudentDocument = {"__meta__":{"hash":"71ee0d5be841c93f5438fbf87e13ba17e817b550"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Student"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"student"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dob"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"gradeLevel"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"middleName"}},{"kind":"Field","name":{"kind":"Name","value":"studentCustomFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sessions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"notes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}},{"kind":"Field","name":{"kind":"Name","value":"riskRating"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"persons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"normalizedName"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastSession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"checkpoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"current"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"summary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"livingSituation"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfSiblings"}},{"kind":"Field","name":{"kind":"Name","value":"peopleCountedOn"}},{"kind":"Field","name":{"kind":"Name","value":"livesMainlyWith"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"avatars"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bodyId"}},{"kind":"Field","name":{"kind":"Name","value":"bodyColor"}},{"kind":"Field","name":{"kind":"Name","value":"eyeColor"}},{"kind":"Field","name":{"kind":"Name","value":"hairColor"}},{"kind":"Field","name":{"kind":"Name","value":"helperId"}},{"kind":"Field","name":{"kind":"Name","value":"shirtColor"}},{"kind":"Field","name":{"kind":"Name","value":"pantsColor"}},{"kind":"Field","name":{"kind":"Name","value":"shoesColor"}}]}}]}}]}}]} as unknown as DocumentNode<StudentQuery, StudentQueryVariables>;
export const StudentsWithLocationDetailsDocument = {"__meta__":{"hash":"ac7ac5aa3723859bfa7766540afcabb7aed674c5"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StudentsWithLocationDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"origin"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QueryOrigin"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"students"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"ACTIVE"}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"origin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"origin"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dob"}},{"kind":"Field","name":{"kind":"Name","value":"parentEmail"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"gradeLevel"}},{"kind":"Field","name":{"kind":"Name","value":"studentCustomFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"persons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"normalizedName"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastSession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"checkpoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"current"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"summary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"livingSituation"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfSiblings"}},{"kind":"Field","name":{"kind":"Name","value":"peopleCountedOn"}},{"kind":"Field","name":{"kind":"Name","value":"livesMainlyWith"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"avatars"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bodyId"}},{"kind":"Field","name":{"kind":"Name","value":"bodyColor"}},{"kind":"Field","name":{"kind":"Name","value":"eyeColor"}},{"kind":"Field","name":{"kind":"Name","value":"hairColor"}},{"kind":"Field","name":{"kind":"Name","value":"helperId"}},{"kind":"Field","name":{"kind":"Name","value":"shirtColor"}},{"kind":"Field","name":{"kind":"Name","value":"pantsColor"}},{"kind":"Field","name":{"kind":"Name","value":"shoesColor"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]} as unknown as DocumentNode<StudentsWithLocationDetailsQuery, StudentsWithLocationDetailsQueryVariables>;
export const GetPersonDocument = {"__meta__":{"hash":"e9c53030db8b9e497ab25897da4e21adbbb5940d"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPerson"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"origin"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QueryOrigin"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"students"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"origin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"origin"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"dob"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetPersonQuery, GetPersonQueryVariables>;
export const WorkListsByPersonDocument = {"__meta__":{"hash":"97632c6da13c0c20e04825fbbd56884557a13a17"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WorkListsByPerson"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"workLists"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"notes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"session"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"student"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]} as unknown as DocumentNode<WorkListsByPersonQuery, WorkListsByPersonQueryVariables>;
export const MeDocument = {"__meta__":{"hash":"7cb8497358fb386699ea32d412669cc7427e7c60"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"paidUsers"}},{"kind":"Field","name":{"kind":"Name","value":"activeUsers"}},{"kind":"Field","name":{"kind":"Name","value":"companySubscriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"subscription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"companyConsentPolicy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"needParentalConsent"}},{"kind":"Field","name":{"kind":"Name","value":"autoParentalConsent"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"dashboardStats"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentLocationStudents"}},{"kind":"Field","name":{"kind":"Name","value":"totalStudents"}},{"kind":"Field","name":{"kind":"Name","value":"sessionsCompleteThisWeek"}},{"kind":"Field","name":{"kind":"Name","value":"changeFromLastWeek"}},{"kind":"Field","name":{"kind":"Name","value":"pendingConsent"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"streetLineOne"}},{"kind":"Field","name":{"kind":"Name","value":"streetLineTwo"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"customFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"workLists"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"UNREAD"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"defaultLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"streetLineOne"}},{"kind":"Field","name":{"kind":"Name","value":"streetLineTwo"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"demoStudent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MeQuery, MeQueryVariables>;
export const PendingStudentsDocument = {"__meta__":{"hash":"4ae318ecd8720c62e5795e8393fc1874741c8ae8"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"pendingStudents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"origin"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QueryOrigin"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"students"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"origin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"origin"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentalConsentStatus"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PendingStudentsQuery, PendingStudentsQueryVariables>;
export const GetKeywordAnswersForSessionDocument = {"__meta__":{"hash":"1134a989e0aba2ad90b34551143d780c84125ec3"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetKeywordAnswersForSession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sessionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"keywordAnswersForSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sessionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sessionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"question"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"answerCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"keywordId"}},{"kind":"Field","name":{"kind":"Name","value":"keyword"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"wordOrPhrase"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetKeywordAnswersForSessionQuery, GetKeywordAnswersForSessionQueryVariables>;
export const StudentSessionsDocument = {"__meta__":{"hash":"fd80a420f1f4727898c522ddbd3afbce081678aa"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StudentSessions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"studentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"student"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"studentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"parentEmail"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"dob"}},{"kind":"Field","name":{"kind":"Name","value":"expired"}},{"kind":"Field","name":{"kind":"Name","value":"parentalConsentStatus"}},{"kind":"Field","name":{"kind":"Name","value":"lastConsentAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"consentEmailSentTimes"}},{"kind":"Field","name":{"kind":"Name","value":"sessions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"NullValue"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"riskRating"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"hasKeyWords"}},{"kind":"Field","name":{"kind":"Name","value":"checkpoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"current"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"launchPerson"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"worklist"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"notes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"normalizedName"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"history"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<StudentSessionsQuery, StudentSessionsQueryVariables>;
export const UnreadWorkListDocument = {"__meta__":{"hash":"2acff665fdd5189971d6469fa0971e9ca3d5b850"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UnreadWorkList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workLists"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"UNREAD"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"session"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"student"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]} as unknown as DocumentNode<UnreadWorkListQuery, UnreadWorkListQueryVariables>;
export const GetPersonWithLocationsForLinkDocument = {"__meta__":{"hash":"61c850c9d16a6a28d4b3427a6e842714c723bf5b"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPersonWithLocationsForLink"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"personId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"person"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"personId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"singleStudents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locationId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetPersonWithLocationsForLinkQuery, GetPersonWithLocationsForLinkQueryVariables>;
export const PersonStudentsWithLocationDocument = {"__meta__":{"hash":"b00f578c972d36f00df5f6737f0ee018b34cff1d"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"personStudentsWithLocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"personId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"person"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"personId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationStudents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"ACTIVE"}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"dob"}},{"kind":"Field","name":{"kind":"Name","value":"references"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"persons"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"personId"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]} as unknown as DocumentNode<PersonStudentsWithLocationQuery, PersonStudentsWithLocationQueryVariables>;
export const GetPersonLocationsDocument = {"__meta__":{"hash":"2b5db5c2f6a91bd7c37a2b5fb16da20d08779951"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPersonLocations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"personId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"person"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"personId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"singleStudents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locationId"}},{"kind":"Field","name":{"kind":"Name","value":"references"}}]}}]}}]}}]} as unknown as DocumentNode<GetPersonLocationsQuery, GetPersonLocationsQueryVariables>;
export const PersonStudentAssignDocument = {"__meta__":{"hash":"6c8713b9d971e80140b31ea1a9821c6ed1614a43"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PersonStudentAssign"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"personId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"studentIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"assignPersonStudents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"personId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"personId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"studentIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"studentIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ValidationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldName"}},{"kind":"Field","name":{"kind":"Name","value":"messages"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<PersonStudentAssignMutation, PersonStudentAssignMutationVariables>;
export const PersonStudentUnassignDocument = {"__meta__":{"hash":"4577dcdc4b4cc12f4887d2ee6145174321b78779"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PersonStudentUnassign"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"personId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"studentIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unassignPersonStudents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"personId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"personId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"studentIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"studentIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ValidationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldName"}},{"kind":"Field","name":{"kind":"Name","value":"messages"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<PersonStudentUnassignMutation, PersonStudentUnassignMutationVariables>;
export const StudentPersonsLinkDocument = {"__meta__":{"hash":"a4abc5f1f1178b78b43f54fc28e15b9810263136"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"studentPersonsLink"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"studentId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"role"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"persons"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"ACTIVE"}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"role"},"value":{"kind":"Variable","name":{"kind":"Name","value":"role"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"_person"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"_person"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"middleName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"expired"}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"normalizedName"}},{"kind":"Field","name":{"kind":"Name","value":"clientFacingName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"students"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"studentId"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"ACTIVE"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"references"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<StudentPersonsLinkQuery, StudentPersonsLinkQueryVariables>;
export const StudentQueryDocument = {"__meta__":{"hash":"9b9747ae2a9fe769f6ae0cac579e1be003c3944d"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StudentQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"studentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"student"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"studentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locationId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"middleName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"dob"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"parentEmail"}},{"kind":"Field","name":{"kind":"Name","value":"parentPhone"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"expired"}},{"kind":"Field","name":{"kind":"Name","value":"references"}},{"kind":"Field","name":{"kind":"Name","value":"studentCustomFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"customField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"locations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"customFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}}]}}]}}]} as unknown as DocumentNode<StudentQueryQuery, StudentQueryQueryVariables>;
export const EditStudentDocument = {"__meta__":{"hash":"dd2265717e2c6485394c373eb82550f3812002f1"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EditStudent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EditStudentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editStudent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"student"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UnknownError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ValidationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldName"}},{"kind":"Field","name":{"kind":"Name","value":"messages"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EntityNotFoundError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<EditStudentMutation, EditStudentMutationVariables>;
export const StudentNotesDocument = {"__meta__":{"hash":"682a40ad2ec1af6f0e26bb762475955075366532"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StudentNotes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"studentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"student"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"studentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"allNotes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"origin"}},{"kind":"Field","name":{"kind":"Name","value":"sessionNotes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"session"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"normalizedName"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<StudentNotesQuery, StudentNotesQueryVariables>;
export const StudentPersonsLinkPreviewDocument = {"__meta__":{"hash":"a6f6729ebc37d321b5eca8ad1df55c18366757c5"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StudentPersonsLinkPreview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"studentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"student"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"studentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"references"}},{"kind":"Field","name":{"kind":"Name","value":"persons"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"ACTIVE"}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"_studentPerson"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"_studentPerson"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"normalizedName"}},{"kind":"Field","name":{"kind":"Name","value":"clientFacingName"}}]}}]}}]} as unknown as DocumentNode<StudentPersonsLinkPreviewQuery, StudentPersonsLinkPreviewQueryVariables>;
export const ExpireStudentDocument = {"__meta__":{"hash":"e4384d5fb7255204414a68ffdafa9b00d96b79df"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ExpireStudent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"expireStudent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"student"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"expired"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ValidationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldName"}},{"kind":"Field","name":{"kind":"Name","value":"messages"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EntityLockedError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"entity"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EntityNotFoundError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UnknownError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ExpireStudentMutation, ExpireStudentMutationVariables>;
export const SelectedStudentDocument = {"__meta__":{"hash":"71fa69cd4e71ea2c8bf8f24dcf90c76deda6635b"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SelectedStudent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"student"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SelectedStudent_Student"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SelectedStudent_Student"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Student"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locationId"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"middleName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"dob"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"parentEmail"}},{"kind":"Field","name":{"kind":"Name","value":"parentPhone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"expired"}},{"kind":"Field","name":{"kind":"Name","value":"references"}},{"kind":"Field","name":{"kind":"Name","value":"parentalConsentStatus"}},{"kind":"Field","name":{"kind":"Name","value":"lastConsentAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"consentEmailSentTimes"}},{"kind":"Field","name":{"kind":"Name","value":"persons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"studentCustomFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"customField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<SelectedStudentQuery, SelectedStudentQueryVariables>;
export const StudentPersonsAssignDocument = {"__meta__":{"hash":"5623e88a5a68cd2a0292887b174ea3f0c351869a"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StudentPersonsAssign"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"studentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"personIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignStudentPersons"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"studentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"studentId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"personIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"personIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"student"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"references"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ValidationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldName"}},{"kind":"Field","name":{"kind":"Name","value":"messages"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<StudentPersonsAssignMutation, StudentPersonsAssignMutationVariables>;
export const StudentPersonsUnassignDocument = {"__meta__":{"hash":"95a8bbb8f2cdbb3acbb42e777b14282520bc27b8"},"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StudentPersonsUnassign"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"studentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"personIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unassignStudentPersons"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"studentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"studentId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"personIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"personIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"student"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"references"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ValidationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldName"}},{"kind":"Field","name":{"kind":"Name","value":"messages"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<StudentPersonsUnassignMutation, StudentPersonsUnassignMutationVariables>;